
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bbZCI", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");

var $be94966e4863f9c3$exports = {};

var $KnbfF = parcelRequire("KnbfF");


var $6YjyC = parcelRequire("6YjyC");

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $be94966e4863f9c3$var$find = $KnbfF($6YjyC);
$be94966e4863f9c3$exports = $be94966e4863f9c3$var$find;



var $kyKWe = parcelRequire("kyKWe");


var $dOBRD = parcelRequire("dOBRD");


var $9DHhW = parcelRequire("9DHhW");


var $5Tdig = parcelRequire("5Tdig");


var $eYg5X = parcelRequire("eYg5X");


var $cH0F8 = parcelRequire("cH0F8");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $1P7Cq = parcelRequire("1P7Cq");


var $5Abqh = parcelRequire("5Abqh");


var $kVysQ = parcelRequire("kVysQ");


var $9eE57 = parcelRequire("9eE57");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $id4ij = parcelRequire("id4ij");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aMcHK = parcelRequire("aMcHK");


var $4PPzL = parcelRequire("4PPzL");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");


var $6mKj3 = parcelRequire("6mKj3");


var $gqqjz = parcelRequire("gqqjz");


var $ep3mz = parcelRequire("ep3mz");


var $7xVCs = parcelRequire("7xVCs");


var $dncjA = parcelRequire("dncjA");


var $ficwO = parcelRequire("ficwO");


var $dPJCf = parcelRequire("dPJCf");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $56QzY = parcelRequire("56QzY");


var $39rFu = parcelRequire("39rFu");


var $7Sm4c = parcelRequire("7Sm4c");


var $huWyw = parcelRequire("huWyw");


var $bI0Bv = parcelRequire("bI0Bv");


var $bQm3c = parcelRequire("bQm3c");


var $de2j9 = parcelRequire("de2j9");


var $lqy4C = parcelRequire("lqy4C");


var $6g38M = parcelRequire("6g38M");


var $ivyMZ = parcelRequire("ivyMZ");


var $lUMkS = parcelRequire("lUMkS");








var $3aAh8 = parcelRequire("3aAh8");

function $23e76f192fd1fdb2$export$4240bef965f11267({ item: item, ...passThroughRenderItemParams }, additionalParams) {
    const { scrollToItem: scrollToItem, onPageHighlighted: onPageHighlighted, onClick: onClick, onExpand: onExpand, onCollapse: onCollapse, spaceId: spaceId, openQuickActionsId: openQuickActionsId, focusedQuickActionsId: focusedQuickActionsId, editingTitle: editingTitle, pageTreeWasSSRRendered: pageTreeWasSSRRendered, getContentTreeSize: getContentTreeSize, renderServerPlaceholder: renderServerPlaceholder = false, ...passThroughAdditionalParams } = additionalParams;
    const isDraft = item.data.status === 'DRAFT';
    const contentStatus = item.data.status;
    const scrollToRef = (()=>{
        // skip scrollTo if page is SSR'd, SSR scrolling is handled by separate script
        if (!pageTreeWasSSRRendered) return (el)=>{
            scrollToItem(item, el);
        };
    })();
    const isQuickActionsOpen = openQuickActionsId === item.id;
    const isQuickActionsFocused = focusedQuickActionsId === item.id;
    const onHighlight = ()=>onPageHighlighted(item.id);
    const onClickWithItem = (event)=>{
        onClick(event, item, onExpand, onCollapse, spaceId, getContentTreeSize);
    };
    const pageItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "item",
        "data-testid": "page-tree-item-wrapper",
        "data-vc": "page-tree-item-wrapper",
        // oxlint-disable-next-line check-no-ssr-placeholder-attributes/no-ssr-placeholder-attributes
        "data-ssr-placeholder": renderServerPlaceholder && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false) ? `pagetree-ssr-${item.id}` : undefined,
        // oxlint-disable-next-line check-no-ssr-placeholder-attributes/no-ssr-placeholder-attributes
        "data-ssr-placeholder-replace": window.__SSR_RENDERED__ === true && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false) ? `pagetree-ssr-${item.id}` : undefined,
        ref: scrollToRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aAh8.PageTreeItem), {
        ...passThroughRenderItemParams,
        ...passThroughAdditionalParams,
        "data-testid": "page-tree-item",
        item: item,
        onHighlight: onHighlight,
        onClick: onClickWithItem,
        isQuickActionsOpen: isQuickActionsOpen,
        isQuickActionsFocused: isQuickActionsFocused,
        editingTitle: editingTitle,
        isDraft: isDraft,
        contentStatus: contentStatus,
        renderServerPlaceholder: renderServerPlaceholder && (0, $6mKj3.expVal)('page_tree_performance', 'isEnabled', false)
    }));
    return pageItem;
}



var $55DRn = parcelRequire("55DRn");


var $88DkZ = parcelRequire("88DkZ");

class $cb5c80eb65176243$export$fbe5b8b514d54d78 {
    push({ undo: undo }) {
        this.stack.push({
            undo: undo
        });
        this.stack = this.stack.slice(-1 * this.size);
    }
    constructor(){
        this.size = 1;
        this.stack = [];
        this.pop = ()=>this.stack.pop();
        this.peek = ()=>this.stack.slice(-1)[0];
        this.reset = ()=>{
            this.stack = [];
        };
    }
}



var $1q7H7 = parcelRequire("1q7H7");


var $6FfmH = parcelRequire("6FfmH");


var $cdzEA = parcelRequire("cdzEA");


var $6CrbN = parcelRequire("6CrbN");


var $bP5d8 = parcelRequire("bP5d8");


var $ebKUU = parcelRequire("ebKUU");

const $a4f80453e05e0dd2$var$noop = ()=>{};
const $a4f80453e05e0dd2$var$canMoveInSpace = (0, $dOBRD.default)((space)=>{
    return !!(0, (/*@__PURE__*/$parcel$interopDefault($be94966e4863f9c3$exports)))(space?.operations ?? [], {
        targetType: 'page',
        operation: 'create'
    });
}, ([newSpace], [lastSpace])=>{
    return newSpace?.id === lastSpace?.id;
});
const $a4f80453e05e0dd2$var$isMovePagePermissionError = ({ graphQLErrors: graphQLErrors })=>{
    if (!graphQLErrors?.length) return false;
    for (const graphQLError of graphQLErrors){
        if (Array.isArray(graphQLError.path) && graphQLError.path.some((p)=>p.includes('movePage')) && (0, $aMcHK.getStatusCode)(graphQLError) === '403') return true;
        if (graphQLError.message?.includes('PermissionException')) return true;
    }
    return false;
};
const $a4f80453e05e0dd2$var$usePageTreeMoveHistory = ({ spaceKey: spaceKey, flags: flags, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>{
    const previousSpaceKeyRef = (0, $cozmU.useRef)(spaceKey);
    const pageMoveHistoryRef = (0, $cozmU.useRef)(new (0, $cb5c80eb65176243$export$fbe5b8b514d54d78)());
    const undo = (0, $cozmU.useCallback)(()=>{
        const reverseMovement = pageMoveHistoryRef.current.pop();
        if (reverseMovement) {
            const { undo: undoFn } = reverseMovement;
            if (undoFn) undoFn();
        }
    }, []);
    const onUndoShortcut = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $88DkZ.undoShortcutUIEvent)()).fire();
        undo();
    }, [
        createAnalyticsEvent,
        undo
    ]);
    const showUndoFlag = (0, $cozmU.useCallback)((pageTitle)=>{
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        flags.showSuccessFlag({
            id: id,
            title: pageTitle ? intl.formatMessage((0, $bP5d8.i18n).flagUndoTitle, {
                pageTitle: pageTitle
            }) : intl.formatMessage((0, $bP5d8.i18n).flagUndoUntitled),
            actions: [
                {
                    content: intl.formatMessage((0, $bP5d8.i18n).flagUndoAction),
                    onClick: ()=>{
                        createAnalyticsEvent((0, $88DkZ.undoClickUIEvent)()).fire();
                        undo();
                        flags.hideFlag(id);
                    }
                }
            ],
            isAutoDismiss: true
        });
        const historyEntry = pageMoveHistoryRef.current.peek();
        if (historyEntry) historyEntry.flagId = id;
    }, [
        flags,
        intl,
        createAnalyticsEvent,
        undo
    ]);
    const hideLastUndoFlag = (0, $cozmU.useCallback)(()=>{
        const lastMovement = pageMoveHistoryRef.current.peek();
        if (lastMovement) flags.hideFlag(lastMovement.flagId);
    }, [
        flags
    ]);
    const addUndo = (0, $cozmU.useCallback)(({ undo: undo_0 })=>{
        pageMoveHistoryRef.current.push({
            undo: undo_0
        });
    }, []);
    if (spaceKey !== previousSpaceKeyRef.current) {
        previousSpaceKeyRef.current = spaceKey;
        hideLastUndoFlag();
        pageMoveHistoryRef.current.reset();
    }
    return {
        onUndoShortcut: onUndoShortcut,
        showUndoFlag: showUndoFlag,
        hideLastUndoFlag: hideLastUndoFlag,
        addUndo: addUndo
    };
};
const $a4f80453e05e0dd2$var$useScrollToItem = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer } = t0;
    const scrolledItemIdRef = (0, $cozmU.useRef)();
    let t1;
    if ($[0] !== pageTreeStateUpdatesContainer) {
        t1 = (item, el)=>{
            if (pageTreeStateUpdatesContainer.state.scrollToPageId === item.id && el) {
                (0, $id4ij.scrollElementToViewCenter)(el);
                pageTreeStateUpdatesContainer.clearScrollToPageId();
                return;
            }
            if (!pageTreeStateUpdatesContainer.state.editingTitle?.contentId && (item.data.isSelected || item.data.isHighlighted)) {
                if (pageTreeStateUpdatesContainer.state.scrollToCurrent && item.data.isSelected && el) {
                    (0, $id4ij.scrollElementToViewCenter)(el);
                    pageTreeStateUpdatesContainer.clearScrollTo();
                    return;
                }
                if (scrolledItemIdRef.current !== item.id) (0, $id4ij.scrollElementToViewCenter)(el);
                scrolledItemIdRef.current = item.id;
            }
        };
        $[0] = pageTreeStateUpdatesContainer;
        $[1] = t1;
    } else t1 = $[1];
    const scrollToItem = t1;
    let t2;
    if ($[2] !== scrollToItem) {
        t2 = [
            scrollToItem
        ];
        $[2] = scrollToItem;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
const $a4f80453e05e0dd2$var$usePageHighlight = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
    } else t1 = $[0];
    const completedHighlightIds = (0, $cozmU.useRef)(t1);
    const activeHighlightPages = (0, $cozmU.useRef)(null);
    let t2;
    if ($[1] !== pageTreeStateUpdatesContainer) {
        t2 = (id)=>{
            const highlightedPageIds = pageTreeStateUpdatesContainer.state.highlightPagesIds;
            if (activeHighlightPages.current !== highlightedPageIds) {
                activeHighlightPages.current = highlightedPageIds;
                completedHighlightIds.current.clear();
            }
            const highlightedPageId = String(id);
            if (!highlightedPageIds.includes(highlightedPageId)) return;
            completedHighlightIds.current.add(highlightedPageId);
            if (highlightedPageIds.every((pageId)=>completedHighlightIds.current.has(pageId))) {
                pageTreeStateUpdatesContainer.clearHighlightedPages();
                activeHighlightPages.current = null;
                completedHighlightIds.current.clear();
            }
        };
        $[1] = pageTreeStateUpdatesContainer;
        $[2] = t2;
    } else t2 = $[2];
    const onPageHighlighted = t2;
    let t3;
    if ($[3] !== onPageHighlighted) {
        t3 = [
            onPageHighlighted
        ];
        $[3] = onPageHighlighted;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
/**
 * This component is what makes the generic `PageTreeController` into a fully functional
 * navigational Page Tree that we all love. It is the one to actually handle things like:
 *  - analytics, performance, and experience tracking events
 *  - backend mutations after drag-n-drop
 *  - orchestrating "undo" for the d-n-d
 *  - showing flags of various kinds (successes/failures). Although triggers for these might originate in other components.
 */ const $a4f80453e05e0dd2$var$PageTreeInner = ({ initialDataFragmentRef: initialDataFragmentRef, isInDrawer: isInDrawer = false, onDragDropSuccess: onDragDropSuccess = $a4f80453e05e0dd2$var$noop, onItemClick: onItemClick, isPeekingFromBlogs: isPeekingFromBlogs, isSuperAdmin: isSuperAdmin = false, pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer, flags: flags, setIsPageTreeLoading: setIsPageTreeLoading, setPageTreeError: setPageTreeError = $a4f80453e05e0dd2$var$noop, isHoverPageCardOptedIn: isHoverPageCardOptedIn = false, closeAllHoverPageCards: closeAllHoverPageCards = $a4f80453e05e0dd2$var$noop, onEnterHoverTarget: onEnterHoverTarget = $a4f80453e05e0dd2$var$noop, onLeaveHoverTarget: onLeaveHoverTarget = $a4f80453e05e0dd2$var$noop, onBlurHoverTarget: onBlurHoverTarget = $a4f80453e05e0dd2$var$noop, shouldRenderAfterIcon: shouldRenderAfterIcon, homepageId: homepageId, setContentTreeSize: setContentTreeSize = $a4f80453e05e0dd2$var$noop, setIsPageTreeEmpty: setIsPageTreeEmpty = $a4f80453e05e0dd2$var$noop, onContentTreeLoadComplete: onContentTreeLoadComplete = $a4f80453e05e0dd2$var$noop })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [{ spaceKey: spaceKey, contentId: contentId, contentIdLoading: contentIdLoading, routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { isHideTitleInUrl: isHideTitleInUrl } = (0, $bQm3c.useSessionData)();
    const typeSafeSpaceKey = spaceKey || '';
    // Many analytics callbacks are sending the current viewing page. The problem is these callbacks are passed to every page tree item.
    // If we use contentId directly the callback functions are going to be regenerated and making all page tree items re-render.
    const contentIdForAnalyticsRef = (0, $cozmU.useRef)(contentId);
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const [openQuickActionsId, setOpenQuickActionsId] = (0, $cozmU.useState)(null);
    const [focusedQuickActionsId, setFocusedQuickActionsId] = (0, $cozmU.useState)(null);
    const { setIsDraggingItem: setIsDraggingItem, getIsDraggingItem: getIsDraggingItem } = (0, $6CrbN.useIsDragging)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isOnEditRouteRef = (0, $cozmU.useRef)();
    // Trigger child refetch from outside React (e.g. diagram-paste finalize).
    (0, $ficwO.useMessageSubscriber)((0, $ficwO.Message).PageTreeRefreshRequested, (0, $cozmU.useCallback)(({ parentId: parentId })=>{
        pageTreeStateUpdatesContainer.setForceFetchPageId(parentId);
    }, [
        pageTreeStateUpdatesContainer
    ]));
    (0, $cozmU.useEffect)(()=>{
        isOnEditRouteRef.current = isOnEditRoute;
        contentIdForAnalyticsRef.current = contentId;
    }, [
        isOnEditRoute,
        contentId
    ]);
    const renderResourcedEmoji = (0, $cozmU.useRef)(false);
    // Expansion analytics can fire after child loading, so retain the click source by page ID.
    const interactionSourcesRef = (0, $cozmU.useRef)(new Map());
    const recordInteractionSource = (0, $cozmU.useCallback)((pageId, interactionSource)=>{
        interactionSourcesRef.current.set(pageId, interactionSource);
    }, []);
    const consumeInteractionSource = (0, $cozmU.useCallback)((pageId_0)=>{
        const interactionSource_0 = interactionSourcesRef.current.get(pageId_0);
        interactionSourcesRef.current.delete(pageId_0);
        return interactionSource_0;
    }, []);
    const { onUndoShortcut: onUndoShortcut, showUndoFlag: showUndoFlag, hideLastUndoFlag: hideLastUndoFlag, addUndo: addUndo } = $a4f80453e05e0dd2$var$usePageTreeMoveHistory({
        flags: flags,
        intl: intl,
        createAnalyticsEvent: createAnalyticsEvent,
        spaceKey: spaceKey
    });
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'page-tree-page-tree-item'
    });
    const { sendInitiatedEvent: sendInitiatedEvent } = (0, $cH0F8.useConsumptionEvents)();
    const visitPage = (0, $cozmU.useCallback)((event, page, spaceId, getContentTreeSize)=>{
        const contentTreeSize = getContentTreeSize?.();
        closeAllHoverPageCards?.();
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('clicked', spaceId, //spaceId was already passing Undefined
        isInDrawer, page.data?.status, contentIdForAnalyticsRef.current, page.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current, contentTreeSize, typeSafeSpaceKey)).fire();
        // metaKey = ⌘ in macOS or middle scroll mouse button
        // Use default browser behaviour when any of these key was pressed
        if (event.metaKey || event.shiftKey || event.altKey || event.ctrlKey || event.button === 1) {
            event.currentTarget.href = (0, $lpPVE.generatePathWithFeatureCodesQueryParam)(event.currentTarget.href, [
                (0, $71GjD.FeatureCode).PAGE_TREE
            ]);
            return; // let the link's href handle the navigation
        }
        sendInitiatedEvent({
            contentId: page.id,
            spaceKey: typeSafeSpaceKey,
            source: 'PageTree',
            utmSource: 'PAGETREE'
        });
        const url = `${(0, $jlIaF.CONTEXT_PATH)}${page.data?.webui}`;
        const bypassURL = (0, $huWyw.getURLBypassingResumeDraftAction)({
            url: url,
            spaceKey: typeSafeSpaceKey,
            contentType: page?.data?.type,
            editorVersion: page?.data?.editorVersion,
            contentId: page.id
        });
        const isDraft = page.data?.status === 'DRAFT';
        if (isDraft) {
            event.preventDefault();
            event.stopPropagation();
            loadEditor({
                contentId: page.id,
                spaceKey: typeSafeSpaceKey,
                redirectUrl: bypassURL,
                isFabricSupported: page?.data?.editorVersion === 'v2',
                isEmbeddedContent: false
            });
        } else {
            event.preventDefault();
            // When the isHideTitleInUrl setting is on, strip the content title slug from the URL.
            const navUrl = isHideTitleInUrl && (0, $6mKj3.expVal)('confluence_hide_content_title_in_url', 'isEnabled', false) ? (0, $bI0Bv.removeContentSlugFromUrl)(url) : url;
            push((0, $lpPVE.generatePathWithFeatureCodesQueryParam)(navUrl, [
                (0, $71GjD.FeatureCode).PAGE_TREE
            ]));
        }
        if (onItemClick) onItemClick();
    }, [
        push,
        onItemClick,
        typeSafeSpaceKey,
        closeAllHoverPageCards,
        createAnalyticsEvent,
        isInDrawer,
        loadEditor,
        isOnEditRouteRef,
        sendInitiatedEvent,
        isHideTitleInUrl
    ]);
    const handleClick = (0, $cozmU.useCallback)((event_0, page_0, onExpand, onCollapse, ...args)=>{
        if (page_0.data.type === 'folder') {
            recordInteractionSource(page_0.id, 'pageTreeItem');
            // Toggle tree expand/collapse and navigate to folder view
            if (page_0.isExpanded) {
                onCollapse?.(page_0.id);
                (0, $eYg5X.default)('page-tree-item-collapse', event_0.timeStamp);
            } else {
                onExpand?.(page_0.id);
                (0, $eYg5X.default)('page-tree-item-expand', event_0.timeStamp);
            }
        }
        // Check for storage enforcement before sending users through to draft pages
        const isDraft_0 = page_0.data?.status === 'DRAFT';
        (isDraft_0 ? enforceStorageLimit(visitPage) : visitPage)(event_0, page_0, ...args);
    }, [
        visitPage,
        enforceStorageLimit,
        recordInteractionSource
    ]);
    const draftText = intl.formatMessage((0, $bP5d8.i18n).untitledDraftText);
    const dragPreview = (0, $cozmU.useCallback)((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cdzEA.DragPreview), {
            item: item
        }), []);
    const statusesRef = (0, $cozmU.useRef)((0, $ivyMZ.PAGE_TREE_STATUSES));
    const [scrollToItem] = $a4f80453e05e0dd2$var$useScrollToItem({
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer
    });
    const [onPageHighlighted] = $a4f80453e05e0dd2$var$usePageHighlight({
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer
    });
    const publishPageTreeUpdate = (0, $dncjA.useOutboundPageTreeUpdatePublisher)((0, $dncjA.OutboundPageTreeMessage).ContentUpdated);
    const { movePage: movePage } = (0, $55DRn.useMovePageHandler)();
    const [dndError, setDnDError] = (0, $cozmU.useState)(null);
    const [initialLoadComplete, setInitialLoadComplete] = (0, $cozmU.useState)(false);
    const [initialPageTreeSize, setInitialPageTreeSize] = (0, $cozmU.useState)(0);
    const pageTreeWasSSRRendered = (0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    if (!renderResourcedEmoji.current && pageTreeWasSSRRendered) renderResourcedEmoji.current = true;
    const managedOnEnterHoverTarget = (0, $cozmU.useCallback)((...args_0)=>{
        // while a drag is occurring, we don't also items to have their hover action triggered
        if (!getIsDraggingItem()) onEnterHoverTarget(...args_0);
    }, [
        onEnterHoverTarget,
        getIsDraggingItem
    ]);
    const editingTitle = pageTreeStateUpdatesContainer.state.editingTitle;
    const isEditingTitleId = editingTitle?.contentId;
    const setIsEditingTitleId = (0, $cozmU.useCallback)((pageId_1)=>{
        return pageTreeStateUpdatesContainer.setIsEditingTitleId(pageId_1);
    }, [
        pageTreeStateUpdatesContainer
    ]);
    const clearDelete = (0, $cozmU.useCallback)(()=>{
        pageTreeStateUpdatesContainer.clearOptimisticDeleteId();
    }, [
        pageTreeStateUpdatesContainer
    ]);
    /**
   * We are registering an "open layer" when the quick actions panel is open, or if we are renaming
   * a page title.
   *
   * This is used to keep the side nav flyout open while the user is renaming a page inline.
   */ (0, $5Tdig.useNotifyOpenLayerObserver)({
        isOpen: Boolean(openQuickActionsId || isEditingTitleId),
        // Providing a noop for now. In the future, we may want to cancel any pending renames when a close
        // signal is received. This will be explored in https://jplat.atlassian.net/browse/BLU-7168
        onClose: $a4f80453e05e0dd2$var$noop
    });
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const renderItem = (0, $cozmU.useCallback)((params)=>{
        const { spaceHomePageId: spaceHomePageId, updateSinglePage: updateSinglePage, spaceId: spaceId_0, getContentTreeSize: getContentTreeSize_0, ...renderItemParams } = params;
        return (0, $23e76f192fd1fdb2$export$4240bef965f11267)(renderItemParams, {
            draftText: draftText,
            isSuperAdmin: isSuperAdmin,
            spaceHomePageId: spaceHomePageId,
            onClick: handleClick,
            onExpand: renderItemParams.onExpand,
            onCollapse: renderItemParams.onCollapse,
            onInteractionSourceChange: recordInteractionSource,
            spaceKey: typeSafeSpaceKey,
            spaceId: spaceId_0,
            scrollToItem: scrollToItem,
            onPageHighlighted: onPageHighlighted,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            closeAllHoverPageCards: closeAllHoverPageCards,
            openQuickActionsId: openQuickActionsId,
            setOpenQuickActionsId: setOpenQuickActionsId,
            focusedQuickActionsId: focusedQuickActionsId,
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            editingTitle: editingTitle,
            setIsEditingTitleId: setIsEditingTitleId,
            onEnterHoverTarget: managedOnEnterHoverTarget,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget,
            updateSinglePage: updateSinglePage,
            pageTreeWasSSRRendered: pageTreeWasSSRRendered,
            renderResourcedEmoji: renderResourcedEmoji.current,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            hideDraftHrefs: shouldBlockCreate,
            getContentTreeSize: getContentTreeSize_0,
            renderServerPlaceholder: renderServerPlaceholder
        });
    }, [
        draftText,
        isSuperAdmin,
        handleClick,
        recordInteractionSource,
        scrollToItem,
        typeSafeSpaceKey,
        onPageHighlighted,
        isHoverPageCardOptedIn,
        closeAllHoverPageCards,
        openQuickActionsId,
        focusedQuickActionsId,
        editingTitle,
        setIsEditingTitleId,
        managedOnEnterHoverTarget,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        pageTreeWasSSRRendered,
        shouldRenderAfterIcon,
        renderResourcedEmoji,
        shouldBlockCreate,
        renderServerPlaceholder
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (pageTreeWasSSRRendered) //set FMP now if SSR rendered and we didn't skip pageTree rendering
        (0, $1q7H7.PAGE_TREE_METRIC).markFMP((0, $9eE57.getMark)('CFP-63.ssr-ttr'));
    }, [
        pageTreeWasSSRRendered
    ]);
    const onLoadError = (0, $cozmU.useCallback)((error, options)=>{
        flags.showErrorFlag({
            title: intl.formatMessage((0, $bP5d8.i18n).flagErrorTitle),
            description: options?.errorLocation ? intl.formatMessage((0, $bP5d8.i18n).paginateErrorDescription) : intl.formatMessage((0, $bP5d8.i18n).flagErrorDescription),
            isAutoDismiss: true
        });
        if (options?.isExpected) // This is a temporary measure as we gradually improve PageTree error handling.
        // Normally expected errors should not render a generic error component and
        // instead should provide an error-specific experience.
        experienceTracker.succeed({
            name: (0, $irVI7.PAGE_TREE_EXPERIENCE)
        });
        else {
            setPageTreeError(error);
            experienceTracker.stopOnError({
                name: (0, $irVI7.PAGE_TREE_EXPERIENCE),
                attributes: {
                    location: options?.errorLocation || 'main'
                },
                error: error
            });
        }
    }, [
        flags,
        intl,
        experienceTracker,
        setPageTreeError
    ]);
    const onPageMove = (0, $cozmU.useCallback)((moveParams, { contentStatus: contentStatus, movedPageTitle: movedPageTitle, spaceId: spaceId_1, source: source, destination: destination, instructionType: instructionType, revertMove: revertMove })=>{
        createAnalyticsEvent((0, $88DkZ.dragEndUIEvent)(true)).fire();
        const handleDragDropSuccess = (spaceId_2, pageId_2, sourceParentId, destinationParentId, instructionType_0, isAmnPage = false)=>{
            createAnalyticsEvent((0, $88DkZ.dragDropEndTrackEvent)({
                source: 'PageTree',
                contentStatus: contentStatus,
                pageId: pageId_2,
                previousParentPageId: sourceParentId,
                newParentPageId: destinationParentId,
                previousSpaceId: spaceId_2,
                newSpaceId: spaceId_2,
                isOnEditRoute: isOnEditRouteRef.current,
                instructionType: instructionType_0,
                isAmnPage: isAmnPage
            })).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE)
            });
            publishPageTreeUpdate({
                contentId: pageId_2,
                parentId: destinationParentId
            });
            onDragDropSuccess(pageId_2);
        };
        const handleDndError = (apolloError)=>{
            // undo the move in state so that the tree reflects that the move did not succeed
            revertMove();
            if (!apolloError) return;
            const i18nMessage = (0, $6FfmH.getI18nMessageForKnownError)(apolloError);
            if (i18nMessage !== undefined) {
                (0, $7Sm4c.markErrorAsHandled)(apolloError);
                flags.showErrorFlag({
                    title: i18nMessage.title.defaultMessage,
                    description: i18nMessage.description.defaultMessage,
                    isAutoDismiss: true
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    attributes: {
                        expectedErrorDescription: i18nMessage.description.defaultMessage
                    }
                });
            } else if ($a4f80453e05e0dd2$var$isMovePagePermissionError(apolloError)) {
                (0, $7Sm4c.markErrorAsHandled)(apolloError);
                flags.showErrorFlag({
                    title: intl.formatMessage((0, $bP5d8.i18n).flagMovePagePermissionErrorTitle),
                    description: intl.formatMessage((0, $bP5d8.i18n).flagMovePagePermissionErrorDescription),
                    isAutoDismiss: true
                });
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'User lacks move permissions'
                });
            } else {
                flags.showErrorFlag({
                    title: intl.formatMessage((0, $bP5d8.i18n).flagErrorTitle),
                    description: intl.formatMessage((0, $bP5d8.i18n).flagErrorDescription),
                    isAutoDismiss: true
                });
                experienceTracker.stopOnError({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    error: apolloError
                });
            }
            setDnDError(apolloError);
        };
        const makeMovePageRequests = async (movePageParams, onMovePageSuccess)=>{
            // Use allSettled as failures from getAutomatedMeetingNotesPageProperties should not result in a movePage failure
            const [movePageResult, amnPagePropsResult] = await Promise.allSettled([
                movePage(movePageParams).then(onMovePageSuccess),
                (0, $6g38M.getAutomatedMeetingNotesPageProperties)(movePageParams.pageId)
            ]);
            if (movePageResult.status === 'rejected') throw movePageResult.reason;
            const isAmnPage_0 = amnPagePropsResult.status === 'fulfilled' ? amnPagePropsResult.value.isAMN : undefined;
            return {
                movePageResult: movePageResult.value,
                isAmnPage: isAmnPage_0
            };
        };
        const reverseMove = ()=>{
            const reverseMoveParams = revertMove();
            makeMovePageRequests(reverseMoveParams).then(({ isAmnPage: isAmnPage_1 })=>handleDragDropSuccess(spaceId_1, moveParams.pageId, // If the move is reversed, the source will be the original destination
                // and the destination will be the original source.
                destination.parentId, source.parentId, instructionType, isAmnPage_1)).catch(handleDndError);
        };
        addUndo({
            undo: reverseMove
        });
        makeMovePageRequests(moveParams, ()=>showUndoFlag(movedPageTitle)).then(({ isAmnPage: isAmnPage_2 })=>handleDragDropSuccess(spaceId_1, moveParams.pageId, source.parentId, destination.parentId, instructionType, isAmnPage_2)).catch(handleDndError);
    }, [
        experienceTracker,
        flags,
        intl,
        addUndo,
        movePage,
        showUndoFlag,
        createAnalyticsEvent,
        onDragDropSuccess,
        isOnEditRouteRef,
        publishPageTreeUpdate
    ]);
    const forceFetchedCallback = (0, $cozmU.useCallback)((state)=>{
        const lastForceFetchId = pageTreeStateUpdatesContainer.state.forceFetchPageId;
        pageTreeStateUpdatesContainer.clearForceFetch();
        const newContentId = editingTitle?.contentId;
        // For paginated page trees, force fetch id of the newly created content if the content does not
        // have a create content route. This will enable properly scrolling to the new item
        if ((state.isTreeTruncatedFollowing || state.isTreeTruncatedPrevious) && editingTitle?.isNewContent && lastForceFetchId !== newContentId) pageTreeStateUpdatesContainer.forceFetchWithInlineRename(newContentId, newContentId);
    }, [
        pageTreeStateUpdatesContainer,
        editingTitle
    ]);
    const onMoveInvalid = (0, $cozmU.useCallback)(({ reason: reason })=>{
        createAnalyticsEvent((0, $88DkZ.dragEndUIEvent)(false)).fire();
        const showInvalidMoveDraftFlag = ()=>{
            flags.showErrorFlag({
                title: intl.formatMessage((0, $bP5d8.i18n).flagInvalidMoveDraftTitle),
                description: intl.formatMessage((0, $bP5d8.i18n).flagInvalidMoveDraftDescription),
                isAutoDismiss: true
            });
        };
        switch(reason){
            case 'INVALID_MOVE_LOCATION':
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Invalid move location'
                });
                break;
            case 'INVALID_MOVE_LOCATION_DRAFT':
                showInvalidMoveDraftFlag();
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Invalid move location onto draft'
                });
                break;
            case 'INVALID_MOVE_LOCATION_MANAGED_FOLDER':
                (0, $ebKUU.showInvalidMoveManagedFolderFlag)(flags, intl);
                experienceTracker.abort({
                    name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE),
                    reason: 'Invalid move involving managed folder'
                });
                break;
        }
    }, [
        createAnalyticsEvent,
        experienceTracker,
        flags,
        intl
    ]);
    const onDragStart = (0, $cozmU.useCallback)(()=>{
        closeAllHoverPageCards();
        setOpenQuickActionsId(null);
        createAnalyticsEvent((0, $88DkZ.dragStartUIEvent)()).fire();
        experienceTracker.start({
            name: (0, $irVI7.PAGE_TREE_DND_EXPERIENCE)
        });
        hideLastUndoFlag();
    }, [
        createAnalyticsEvent,
        experienceTracker,
        hideLastUndoFlag,
        closeAllHoverPageCards
    ]);
    const expandAnalyticsCallback = (0, $cozmU.useCallback)((page_1, { spaceId: spaceId_3 })=>{
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('expanded', spaceId_3, isInDrawer, page_1.data?.status, contentIdForAnalyticsRef.current, page_1.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current, undefined, undefined, consumeInteractionSource(page_1.id))).fire();
    }, [
        createAnalyticsEvent,
        isInDrawer,
        isOnEditRouteRef,
        consumeInteractionSource
    ]);
    const collapseAnalyticsCallback = (0, $cozmU.useCallback)((page_2, { spaceId: spaceId_4 })=>{
        createAnalyticsEvent((0, $88DkZ.pageTreeUIAnalytics)('collapsed', spaceId_4, isInDrawer, page_2.data?.status, contentIdForAnalyticsRef.current, page_2.data?.type, (0, $56QzY.START_TOUCH), isOnEditRouteRef.current, undefined, undefined, consumeInteractionSource(page_2.id))).fire();
    }, [
        createAnalyticsEvent,
        isInDrawer,
        isOnEditRouteRef,
        consumeInteractionSource
    ]);
    const isDraggable = (0, $cozmU.useCallback)((item_0, { space: space })=>{
        if (item_0.id === isEditingTitleId) return false;
        return $a4f80453e05e0dd2$var$canMoveInSpace(space);
    }, [
        isEditingTitleId
    ]);
    const onLoadMore = (0, $cozmU.useCallback)((pagesCount, spaceId_5, direction)=>{
        createAnalyticsEvent((0, $88DkZ.pageTreePaginationEvent)(spaceId_5, pagesCount, 'containerNavigation', direction)).fire();
    }, [
        createAnalyticsEvent
    ]);
    /**
   * onInitialLoadComplete is called after the first initial load of the page tree's data. This includes refreshing the page.
   * It does not include returning from blog peek, transitioning from blog BACK to page tree, transitioning amongst pages in page tree, etc.
   */ const onInitialLoadComplete = (0, $cozmU.useCallback)((pagetreeSize)=>{
        (0, $9eE57.perfMarkEnd)({
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: 'NavigationLoading',
            details: {
                navigationView: 'container',
                view: 'space',
                navVersion: 3,
                spaceKey: spaceKey
            }
        });
        (0, $9eE57.perfMarkEnd)({
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigationView),
            subjectId: 'SpaceViewLoading',
            details: {
                navigationView: 'container',
                view: 'space',
                navVersion: 3,
                spaceKey: spaceKey
            }
        });
        experienceTracker.succeed({
            name: (0, $irVI7.PAGE_TREE_EXPERIENCE)
        });
        onContentTreeLoadComplete(); // show blog tree spotlight only after page tree finishes loading to prevent misplaced spotlight
        if (pagetreeSize && pagetreeSize > 2) setInitialPageTreeSize(pagetreeSize - 2); //subtract 2 for VIRTUAL_LOCAL_ROOT_ID and VIRTUAL_ROOT_ID
        setInitialLoadComplete(true);
    }, [
        experienceTracker,
        spaceKey,
        onContentTreeLoadComplete
    ]);
    const currentPageId = pageTreeStateUpdatesContainer.state.forceFetchPageId || (isPeekingFromBlogs ? homepageId : contentId);
    const isCreateContentRoute = routeName === (0, $1NBp8.CREATE_CONTENT).name;
    // Note: content id can be null even when contentIdLoading = false
    // Because a space may not have homepage
    const showPageTree = Boolean(contentId) || !contentIdLoading;
    if (!showPageTree) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $1q7H7.PAGE_TREE_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        key: `experience-${spaceKey}`,
        name: (0, $irVI7.PAGE_TREE_EXPERIENCE),
        id: spaceKey
    }), dndError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: dndError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNDO_SHORTCUT),
        listener: onUndoShortcut
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lUMkS.PageTreeCoordinator), {
        // CONFCLOUD-69158 The key here is forcing page tree to re-mount when switching from space to space
        // This preventing issue when transition from a space that has homepage to a space without
        key: spaceKey,
        initialDataFragmentRef: initialDataFragmentRef,
        statuses: statusesRef.current,
        isPeekingFromBlogs: isPeekingFromBlogs,
        onPageMove: onPageMove,
        onDragStart: onDragStart,
        onMoveInvalid: onMoveInvalid,
        onLoadError: onLoadError,
        onExpand: expandAnalyticsCallback,
        onCollapse: collapseAnalyticsCallback,
        onLoadMore: onLoadMore,
        onInitialLoadComplete: onInitialLoadComplete,
        currentPageId: currentPageId,
        highlightPages: pageTreeStateUpdatesContainer.state.highlightPagesIds,
        forceFetchCurrentPage: Boolean(pageTreeStateUpdatesContainer.state.forceFetchPageId),
        forceFetchedCallback: forceFetchedCallback,
        optimisticDeleteId: pageTreeStateUpdatesContainer.state.optimisticDeletePageId || undefined,
        clearDeleteId: clearDelete,
        spaceKey: typeSafeSpaceKey,
        renderItem: renderItem,
        dragPreview: dragPreview,
        isDraggable: isDraggable,
        setIsPageTreeLoading: setIsPageTreeLoading,
        isSuperAdmin: isSuperAdmin,
        getIsDraggingItem: getIsDraggingItem,
        setIsDraggingItem: setIsDraggingItem,
        renderResourcedEmoji: renderResourcedEmoji.current,
        setContentTreeSize: setContentTreeSize,
        setIsPageTreeEmpty: setIsPageTreeEmpty,
        pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer,
        isCreateContentRoute: isCreateContentRoute,
        flags: flags
    }), (initialLoadComplete || undefined) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $1q7H7.PAGE_TREE_METRIC),
        customData: {
            initialPageTreeSize: initialPageTreeSize,
            skipTreeRenderSSR: !pageTreeWasSSRRendered //tracks if Best effort failed & if tree was over 200 pages
        },
        stopTime: pageTreeWasSSRRendered ? (0, $9eE57.getMark)('CFP-63.ssr-ttr') : undefined
    })));
};
const $a4f80453e05e0dd2$export$73500bf5f2e2b0c4 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t0
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $7xVCs.PageTreeStateUpdater)
                ]
            }, (pageTreeStateUpdatesContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4f80453e05e0dd2$var$PageTreeInner, {
                    ...props,
                    pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer,
                    flags: flags
                }))));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
$a4f80453e05e0dd2$export$73500bf5f2e2b0c4.displayName = 'PageTree';
module.exports["PageTree"] = $a4f80453e05e0dd2$export$73500bf5f2e2b0c4;

});

parcelRegister("KnbfF", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $9pMwd = parcelRequire("9pMwd");


var $f14Rr = parcelRequire("f14Rr");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $08b647270d3840a0$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$9pMwd(collection)) {
            var iteratee = $j6gAQ(predicate, 3);
            collection = $f14Rr(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $08b647270d3840a0$var$createFind;

});

parcelRegister("6YjyC", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $j6gAQ = parcelRequire("j6gAQ");


var $2Ryc1 = parcelRequire("2Ryc1");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $51378455af9aa961$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $51378455af9aa961$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $2Ryc1(fromIndex);
    if (index < 0) index = $51378455af9aa961$var$nativeMax(length + index, 0);
    return $7jN2X(array, $j6gAQ(predicate, 3), index);
}
module.exports = $51378455af9aa961$var$findIndex;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("cH0F8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $04e9M = parcelRequire("04e9M");


var $6ggfK = parcelRequire("6ggfK");


var $iYrVi = parcelRequire("iYrVi");


var $a2hNG = parcelRequire("a2hNG");

const $99b9dc495b87cac6$export$2fc805631456aefd = ()=>{
    const { sendEvent: sendEvent } = (0, $6ggfK.useSendAnalyticsEvents)();
    const dwellTimeHelperRef = (0, $cozmU.useRef)(null);
    const sendErrorEvent = (0, $cozmU.useCallback)((errorMessage, data)=>{
        const unifiedErrorEvent = (0, $a2hNG.createConsumptionErrorEvent)(errorMessage, data);
        sendEvent(unifiedErrorEvent);
    }, [
        sendEvent
    ]);
    const sendInitiatedEvent = (0, $cozmU.useCallback)((data, contentAttributesOverride)=>{
        (0, $iYrVi.loadSpaceAndContentData)(data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionInitiatedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
        }).catch((error)=>sendErrorEvent(error.message, data));
    }, [
        sendErrorEvent,
        sendEvent
    ]);
    const sendViewedEvent = (0, $cozmU.useCallback)((data, contentAttributesOverride)=>{
        (0, $iYrVi.loadSpaceAndContentData)(data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionViewedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
        }).catch((error)=>sendErrorEvent(error.message, data));
    }, [
        sendErrorEvent,
        sendEvent
    ]);
    const sendCompletedEvent = (0, $cozmU.useCallback)((event, dwellTimeHelperData)=>{
        if (dwellTimeHelperData.attributes.finalDwellEvent) {
            const consumptionCompletedEvent = (0, $a2hNG.createConsumptionCompletedEvent)(event, dwellTimeHelperData, // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.visibilityState);
            sendEvent(consumptionCompletedEvent, true);
        }
    }, [
        sendEvent
    ]);
    const sendViewedEventAndCompletedEvent = (0, $cozmU.useCallback)((data, contentAttributesOverride)=>{
        const sendEventPromise = (0, $iYrVi.loadSpaceAndContentData)(data.spaceKey, data.contentId).then((response)=>{
            const event = (0, $a2hNG.createConsumptionViewedEvent)(response, data, contentAttributesOverride);
            sendEvent(event);
            return event;
        });
        Promise.all([
            sendEventPromise,
            (0, $04e9M.getDwellTimeHelper)()
        ]).then(([event, DwellTimeHelper])=>{
            const dwellTimeHelper = new DwellTimeHelper((callbackData)=>sendCompletedEvent(event, callbackData), event.data);
            dwellTimeHelper.start();
            dwellTimeHelperRef.current = dwellTimeHelper;
        }).catch((error)=>{
            sendErrorEvent(error.message, data);
        });
    }, [
        sendEvent,
        sendCompletedEvent,
        sendErrorEvent
    ]);
    const stopDwellTimeTracker = (0, $cozmU.useCallback)(()=>{
        if (dwellTimeHelperRef.current) dwellTimeHelperRef.current.stop();
    }, []);
    return {
        sendInitiatedEvent: sendInitiatedEvent,
        sendViewedEvent: sendViewedEvent,
        sendViewedEventAndCompletedEvent: sendViewedEventAndCompletedEvent,
        sendCompletedEvent: sendCompletedEvent,
        sendErrorEvent: sendErrorEvent,
        stopDwellTimeTracker: stopDwellTimeTracker
    };
};
module.exports["useConsumptionEvents"] = $99b9dc495b87cac6$export$2fc805631456aefd;

});

parcelRegister("6ggfK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $37a7b14bbef74679$export$ba826f94d4d18f90 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sendEvent = (0, $cozmU.useCallback)((event, skipVisibilityCheck = false)=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (document.visibilityState === 'hidden' && !skipVisibilityCheck) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.addEventListener('visibilitychange', ()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.visibilityState === 'visible') createAnalyticsEvent(event).fire();
        }, {
            once: true
        });
        else createAnalyticsEvent(event).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendEvent: sendEvent
    };
};
module.exports["useSendAnalyticsEvents"] = $37a7b14bbef74679$export$ba826f94d4d18f90;

});

parcelRegister("iYrVi", function(module, exports) {

var $45kl0 = parcelRequire("45kl0");


var $c0rhi = parcelRequire("c0rhi");

const $515f7b87fcfa6100$export$22490ad3617f1d6c = async (spaceKey, contentId)=>{
    if (!contentId) return Promise.reject(new Error('Content ID is required'));
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $45kl0.default),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId
        },
        __callerPackage__: "unified-analytics"
    });
    // this is a workaround to handle the case where the content is restricted
    if (!response.error && response?.data?.singleContent === null) return Promise.reject('singleContent is null');
    return response;
};
module.exports["loadSpaceAndContentData"] = $515f7b87fcfa6100$export$22490ad3617f1d6c;

});

parcelRegister("45kl0", function(module, exports) {
/**
 * @generated SignedSource<<4798b74d51b7c1992077de2b481eac37>>
 * @relayHash c95a5f84d5e59d796094fd4369b29459
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b28e85e80da55e089dff774689ea5c0f515bfc059a2b06130bf7d192829bbe6
const $735d6368c1baed2b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "subType"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "getConsumptionEventDataQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "getConsumptionEventDataQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "c95a5f84d5e59d796094fd4369b29459",
            "id": "1b28e85e80da55e089dff774689ea5c0f515bfc059a2b06130bf7d192829bbe6",
            "metadata": {},
            "name": "getConsumptionEventDataQuery",
            "operationKind": "query",
            "text": "query getConsumptionEventDataQuery($spaceKey:String!,$contentId:ID!){space(key:$spaceKey){id,type,status},singleContent(id:$contentId){id,status,type,subType}}"
        }
    };
}();
$735d6368c1baed2b$var$node.hash = "a468aeb5b2dd43bd9bd81e0a81d18bda";
var $735d6368c1baed2b$export$2e2bcd8739ae039 = $735d6368c1baed2b$var$node;
module.exports["default"] = $735d6368c1baed2b$export$2e2bcd8739ae039;

});

parcelRegister("a2hNG", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
const $d12dabfe6ca737c1$export$1931aa92cd9ee803 = (status, contentState)=>{
    if (contentState) return contentState;
    switch(status){
        case 'current':
            return 'published';
        case 'archived':
            return 'archived';
        case 'draft':
            return 'draft';
        default:
            return 'unset';
    }
};
const $d12dabfe6ca737c1$export$3f4d5492ecb52ee5 = (subType, contentMode)=>{
    if (contentMode) return contentMode;
    switch(subType){
        case 'live':
            return 'live';
        case 'embed':
            return 'embedded';
        default:
            return 'classic';
    }
};
const $d12dabfe6ca737c1$export$5e059cd6f8a921d7 = (type, contentType)=>{
    if (contentType) return contentType;
    switch(type){
        case 'page':
            return 'page';
        case 'blogpost':
            return 'blogpost';
        case 'whiteboard':
            return 'whiteboard';
        case 'slide':
            return 'slide';
        case 'database':
            return 'database';
        case 'embed':
            return 'smartlink';
        default:
            return 'unset';
    }
};
const $d12dabfe6ca737c1$export$6d76e0936bf44cc2 = (response, data, contentAttributesOverride)=>{
    const contentType = $d12dabfe6ca737c1$export$5e059cd6f8a921d7(response?.data?.singleContent?.type, contentAttributesOverride?.contentType);
    const contentState = $d12dabfe6ca737c1$export$1931aa92cd9ee803(response?.data?.singleContent?.status, contentAttributesOverride?.contentState);
    const contentMode = $d12dabfe6ca737c1$export$3f4d5492ecb52ee5(response?.data?.singleContent?.subType, contentAttributesOverride?.contentMode);
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: data.source,
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                contentState: contentState,
                spaceId: response?.data?.space?.id ?? 'unset',
                contentId: response?.data?.singleContent?.id ?? 'unset'
            }
        }
    };
};
const $d12dabfe6ca737c1$export$b4ddea3e5241109a = (response, data, contentAttributesOverride)=>{
    const contentType = $d12dabfe6ca737c1$export$5e059cd6f8a921d7(response?.data?.singleContent?.type, contentAttributesOverride?.contentType);
    const contentState = $d12dabfe6ca737c1$export$1931aa92cd9ee803(response?.data?.singleContent?.status, contentAttributesOverride?.contentState);
    const contentMode = $d12dabfe6ca737c1$export$3f4d5492ecb52ee5(response?.data?.singleContent?.subType, contentAttributesOverride?.contentMode);
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'initiated',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: data.source,
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                contentState: contentState,
                spaceId: response?.data?.space?.id ?? 'unset',
                contentId: response?.data?.singleContent?.id ?? 'unset',
                utmSource: data.utmSource
            }
        }
    };
};
const $d12dabfe6ca737c1$export$ea5bf29fc7b309b8 = (event, dwellTimeHelperData, visibilityState)=>{
    return {
        type: 'sendTrackEvent',
        data: {
            ...event.data,
            action: 'completed',
            attributes: {
                ...event.data.attributes,
                dwellTime: dwellTimeHelperData.attributes.dwellTime,
                pageVisibility: visibilityState
            }
        }
    };
};
const $d12dabfe6ca737c1$export$b2d32ef04e5142a1 = (errorMessage, props)=>{
    return {
        type: 'sendTrackEvent',
        data: {
            action: 'error',
            actionSubject: 'consumption',
            actionSubjectId: 'client',
            source: props.source,
            attributes: {
                error: errorMessage,
                contentId: props.contentId ?? 'unset',
                spaceKey: props.spaceKey
            }
        }
    };
};
module.exports["createConsumptionViewedEvent"] = $d12dabfe6ca737c1$export$6d76e0936bf44cc2;
module.exports["createConsumptionInitiatedEvent"] = $d12dabfe6ca737c1$export$b4ddea3e5241109a;
module.exports["createConsumptionCompletedEvent"] = $d12dabfe6ca737c1$export$ea5bf29fc7b309b8;
module.exports["createConsumptionErrorEvent"] = $d12dabfe6ca737c1$export$b2d32ef04e5142a1;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, timeout: timeout, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            timeout: timeout,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("5tx03"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("5tx03", function(module, exports) {

let $3fc94240cbfcef2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3fc94240cbfcef2f$var$load("aLbuU"),
    $3fc94240cbfcef2f$var$load("hhss7"),
    $3fc94240cbfcef2f$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.scrollingElement || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.appendChild(el);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("lpPVE", function(module, exports) {

var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("7xVCs", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kNIYN = parcelRequire("kNIYN");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $kNIYN.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("dncjA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

var $42d2cbe129156e29$export$a35ea3343c58b478 = /*#__PURE__*/ function(OutboundPageTreeMessage) {
    OutboundPageTreeMessage[OutboundPageTreeMessage["ContentUpdated"] = 0] = "ContentUpdated";
    return OutboundPageTreeMessage;
}({});
class $42d2cbe129156e29$var$OutboundPageTreeMessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        if (!this.subscribers[type]) return;
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $42d2cbe129156e29$var$outboundPageTreeBus = new $42d2cbe129156e29$var$OutboundPageTreeMessageBus();
const $42d2cbe129156e29$export$6aa2f5cad92d6f47 = (type)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $42d2cbe129156e29$var$outboundPageTreeBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $42d2cbe129156e29$export$4a84af3f2bf2e18a = (type, callback)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $42d2cbe129156e29$var$outboundPageTreeBus.subscribe(type, callback);
            return ()=>{
                $42d2cbe129156e29$var$outboundPageTreeBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["OutboundPageTreeMessage"] = $42d2cbe129156e29$export$a35ea3343c58b478;
module.exports["useOutboundPageTreeUpdatePublisher"] = $42d2cbe129156e29$export$6aa2f5cad92d6f47;
module.exports["useOutboundPageTreeUpdateSubscriber"] = $42d2cbe129156e29$export$4a84af3f2bf2e18a;

});

parcelRegister("ficwO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

var $6c05dda517103510$export$f69c19e57285b83a = /*#__PURE__*/ function(Message) {
    Message[Message["ContentCreated"] = 0] = "ContentCreated";
    Message[Message["ContentUnarchived"] = 1] = "ContentUnarchived";
    Message[Message["SmartFolderSyncStateChanged"] = 2] = "SmartFolderSyncStateChanged";
    Message[Message["PageTreeRefreshRequested"] = 3] = "PageTreeRefreshRequested";
    Message[Message["ContentRemoved"] = 4] = "ContentRemoved";
    return Message;
}({});
class $6c05dda517103510$var$MessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $6c05dda517103510$var$messageBus = new $6c05dda517103510$var$MessageBus();
const $6c05dda517103510$export$c4ca85b4851515e2 = (type)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $6c05dda517103510$var$messageBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $6c05dda517103510$export$5ecf0545a6d326d0 = (type, data)=>{
    $6c05dda517103510$var$messageBus.publish(type, data);
};
const $6c05dda517103510$export$99473f2ba2f9f18 = (type, callback)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $6c05dda517103510$var$messageBus.subscribe(type, callback);
            return ()=>{
                $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["Message"] = $6c05dda517103510$export$f69c19e57285b83a;
module.exports["useMessagePublisher"] = $6c05dda517103510$export$c4ca85b4851515e2;
module.exports["publishMessage"] = $6c05dda517103510$export$5ecf0545a6d326d0;
module.exports["useMessageSubscriber"] = $6c05dda517103510$export$99473f2ba2f9f18;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $8W4Gr = parcelRequire("8W4Gr");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    // Capture before onComplete or a deferred paint callback can start another interaction.
    const binding = props.metric ? (0, $8W4Gr.getPageSegmentUFOBinding)(props.metric) : undefined;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        const data = {
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        };
        // An imperative start has no embedded context; retain its captured key and owner.
        if (binding && (binding.key === prefixedKey || binding.key === resolvedKey)) // Preserve React end-mark timing; stopTime is metadata on this API.
        (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, {
            customData: data
        });
        else {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
            (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
            (0, $gXfti.addUFOCustomData)(data);
        }
    }, [
        binding,
        onComplete,
        prefixedKey,
        resolvedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $knAY5 = parcelRequire("knAY5");


var $a33Aa = parcelRequire("a33Aa");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $8W4Gr = parcelRequire("8W4Gr");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { metric: metric, onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        // Register the destination for mixed React/imperative consumers without starting BM3.
        const binding = metric ? (0, $8W4Gr.bindPageSegmentToUFO)(metric, prefixedKey) : undefined;
        if (binding) (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`, [], binding.startTime);
        else (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        metric,
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("bI0Bv", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $dee5db4baaee55ac$var$ROUTES_WITH_OPTIONAL_SLUG = [
    (0, $1NBp8.VIEW_PAGE),
    (0, $1NBp8.VIEW_BLOG),
    (0, $1NBp8.VIEW_BLOG_DATE_LEGACY)
];
const $dee5db4baaee55ac$export$75c7d7f506e84d8f = (url)=>{
    for (const route of $dee5db4baaee55ac$var$ROUTES_WITH_OPTIONAL_SLUG){
        const match = route.match(url);
        if (match) {
            const { contentSlug: contentSlug, ...paramsWithoutSlug } = match.params;
            return route.toUrl(paramsWithoutSlug, {
                query: match.query,
                hash: match.hash
            });
        }
    }
    return url;
};
module.exports["removeContentSlugFromUrl"] = $dee5db4baaee55ac$export$75c7d7f506e84d8f;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("lqy4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $cozmU.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $8s9DV.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $kBr4q.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $kBr4q.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("dYU3e", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $iffSy = parcelRequire("iffSy");



var $7Lnfv = parcelRequire("7Lnfv");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$addExtraInfoToError = (error, extraInfo)=>{
    try {
        const existingExtraInfo = Reflect.get(error, 'extraInfo');
        const existingExtraInfoObject = typeof existingExtraInfo === 'object' && existingExtraInfo !== null ? existingExtraInfo : undefined;
        Reflect.set(error, 'extraInfo', {
            ...existingExtraInfoObject,
            ...extraInfo
        });
    } catch  {
    // Some error shapes can be non-extensible. Extra info is best-effort diagnostics.
    }
};
const $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors = (errors, extraInfo)=>{
    errors?.forEach((error)=>{
        $48ba6fb41a85dc7e$var$addExtraInfoToError(error, extraInfo);
    });
};
const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__, relayQueryPreloadRetention: relayQueryPreloadRetention }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    const preloaderErrorExtraInfo = {
        operationName: name ?? 'unknown',
        callerPackage: __callerPackage__
    };
    const queryContext = {
        ...context
    };
    queryContext.headers = {
        ...context?.headers,
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__,
        relayQueryPreloadRetention: relayQueryPreloadRetention
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        if (result.error) $48ba6fb41a85dc7e$var$addExtraInfoToError(result.error, preloaderErrorExtraInfo);
        $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors(errors, preloaderErrorExtraInfo);
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeAggQuery"] = $48ba6fb41a85dc7e$export$5e270d77b1b480de;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("fEmGS", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $bFdYQ = parcelRequire("bFdYQ");


var $bqzdu = parcelRequire("bqzdu");


var $aSAi6 = parcelRequire("aSAi6");


var $9xOXQ = parcelRequire("9xOXQ");


var $7M67g = parcelRequire("7M67g");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Relay builds field storage keys from the operation's *resolved* variables, so a query declaring
    // `$first: Int = 20` normalizes under `field(...,first:20)` even when the caller omits `first`.
    // Resolving the artifact's declared defaults here keeps every Relay write below on the same
    // records Relay normalized and the UI subscribes to; using the raw variables would silently
    // write to a sibling record nobody reads. See getRelayOperationVariablesWithDefaults.
    const variables = (0, $7M67g.getRelayOperationVariablesWithDefaults)(params.query, params.variables);
    // Inside a Relay-native optimistic layer (commitMutation optimisticUpdater/updater), route the
    // write onto the provided store proxy so it participates in Relay's disposable layer instead of
    // committing permanently. This upserts records (incl. connection list changes) via the store
    // proxy — the capability the in-place path lacks — so no snapshot/replay rollback is needed;
    // Relay reverts the whole layer atomically. The cache bridge is intentionally skipped here.
    const ambientStore = (0, $bqzdu.getAmbientStoreProxy)();
    if (ambientStore && source === 'relay' && params.data) {
        const queryNode = params.query;
        const selections = queryNode?.operation?.selections;
        if (selections) {
            (0, $9xOXQ.writeQueryPayloadToStore)(ambientStore, // Normalization selections are a superset of the reader selections the primitive walks
            // (scalar/linked/inline-fragment/condition); matches the cast in writeQueryInteropRelay.
            selections, params.data, variables);
            return;
        }
    }
    const didWrite = source === 'relay' ? $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables) : $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
    if (didWrite) (0, $bFdYQ.syncQueryCacheBridge)({
        source: // The bridge mirrors into the *other* cache, which applies its own document defaults, so it
        // keeps receiving the caller's variables rather than the Relay-resolved ones.
        source,
        query: params.query,
        variables: params.variables,
        data: params.data
    });
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data } = params;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for writeQueryInterop; ${params.__callerPackage__}.`);
    if (!data) return false;
    let didWrite = false;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) didWrite = (0, $aSAi6.writeQueryFields)(root, queryFields, data, variables);
    });
    if (!didWrite) {
        // If no existing Relay records were updated, fall back to Relay's normal payload
        // write path. Invalid Relay artifacts should still throw here, preserving the
        // original writeQueryInterop failure behavior.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), variables);
        relayEnv.commitPayload(operation, data);
        didWrite = true;
    }
    return didWrite;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
    return true;
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("aSAi6", function(module, exports) {

var $2ItkX = parcelRequire("2ItkX");

function $52093bfafa102098$export$77bf2d076cc42a0e(record, fields, data, variables) {
    if (!record || !$52093bfafa102098$var$isObjectRecord(data)) return false;
    // Relay commitUpdate is not transactional. Preflight the selection tree before
    // writing so list rewrites that require Relay normalization fall through to
    // commitPayload instead of committing partial in-place updates.
    if (!$52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables)) return false;
    return $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables);
}
function $52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables) {
    for (const field of fields){
        if (field.kind === 'Condition') {
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude && !$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'InlineFragment') {
            if (!$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) return false;
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords || fieldData.length !== existingRecords.length) return false;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    if (item == null) continue;
                    if (!$52093bfafa102098$var$isObjectRecord(item)) return false;
                    const existingRecord = existingRecords[index];
                    if (!existingRecord || $52093bfafa102098$var$hasDifferentRecordId(existingRecord, item)) return false;
                    if (!$52093bfafa102098$var$canWriteQueryFields(existingRecord, linkedField.selections, item, variables)) return false;
                }
                continue;
            }
            if (!$52093bfafa102098$var$isObjectRecord(fieldData)) return false;
            const linkedRecord = record.getLinkedRecord(fieldKey);
            if (!linkedRecord || $52093bfafa102098$var$hasDifferentRecordId(linkedRecord, fieldData)) return false;
            if (!$52093bfafa102098$var$canWriteQueryFields(linkedRecord, linkedField.selections, fieldData, variables)) return false;
            continue;
        }
        if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && !$52093bfafa102098$var$isRelaySetValue(scalarValue)) return false;
            continue;
        }
    }
    return true;
}
function $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables) {
    let didWrite = false;
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Honour @include/@skip so conditional fields (e.g. userPreferences) get written.
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        } else if (field.kind === 'InlineFragment') didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) continue;
                // Read plural fields with getLinkedRecords; the singular getter throws on
                // plural data. Missing/changed list records are handled by the commitPayload
                // fallback so this in-place path only updates known records.
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords) continue;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    const existingRecord = existingRecords[index];
                    if (existingRecord && $52093bfafa102098$var$isObjectRecord(item)) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(existingRecord, linkedField.selections, item, variables) || didWrite;
                }
            } else if ($52093bfafa102098$var$isObjectRecord(fieldData)) {
                const linkedRecord = record.getLinkedRecord(fieldKey);
                if (linkedRecord) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(linkedRecord, linkedField.selections, fieldData, variables) || didWrite;
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && $52093bfafa102098$var$isRelaySetValue(scalarValue)) {
                record.setValue(scalarValue, (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables));
                didWrite = true;
            }
        }
    }
    return didWrite;
}
function $52093bfafa102098$var$getRecordIdFromData(data) {
    const id = data.id;
    return typeof id === 'string' || typeof id === 'number' ? String(id) : null;
}
function $52093bfafa102098$var$hasDifferentRecordId(record, data) {
    const id = $52093bfafa102098$var$getRecordIdFromData(data);
    return Boolean(id && record.getDataID() !== id);
}
function $52093bfafa102098$var$isObjectRecord(value) {
    return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}
function $52093bfafa102098$var$isRelaySetValue(value) {
    if (Array.isArray(value)) // Relay scalar arrays can contain nulls, but undefined elements are not valid setValue payloads.
    return value.every((item)=>item !== undefined && $52093bfafa102098$var$isRelaySetValue(item));
    return value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
} /* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ 
module.exports["writeQueryFields"] = $52093bfafa102098$export$77bf2d076cc42a0e;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("fqIt3", function(module, exports) {
const $3014a7cdda499b2d$var$collabDraftFetchTimestamps = new Map();
// TTL for CollabDraftQuery cached data
// This prevents stale data during SPA transitions while still allowing
// cache-first for SSR-rendered pages within the TTL window
const $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS = 15000;
/**
 * Creates a composite cache key that includes both contentId and draftShareId.
 * This aligns with how Apollo caches queries by their variables.
 */ const $3014a7cdda499b2d$var$getCacheKey = (contentId, draftShareId)=>{
    return `${contentId}:${draftShareId || ''}`;
};
function $3014a7cdda499b2d$export$76901333d647261(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    const lastFetchTime = $3014a7cdda499b2d$var$collabDraftFetchTimestamps.get(key);
    if (!lastFetchTime) return true;
    return Date.now() - lastFetchTime > $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS;
}
function $3014a7cdda499b2d$export$85437e97168f99bc(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.set(key, Date.now());
}
function $3014a7cdda499b2d$export$5f725cb33e7218ab(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.delete(key);
}
function $3014a7cdda499b2d$export$a379bfa68f31645e() {
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.clear();
}
module.exports["isCollabDraftCacheStale"] = $3014a7cdda499b2d$export$76901333d647261;
module.exports["markCollabDraftFetched"] = $3014a7cdda499b2d$export$85437e97168f99bc;
module.exports["clearCollabDraftTimestamp"] = $3014a7cdda499b2d$export$5f725cb33e7218ab;

});

parcelRegister("nIvaQ", function(module, exports) {

var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $drRzc = parcelRequire("drRzc");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("9eCf8", function(module, exports) {
/**
 * @generated SignedSource<<65ddc58d625028461cf53f05076a93e9>>
 * @relayHash 661233a47ecadf36bf6b55db313a301e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9
const $b0adf32477ccbbfa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v6 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v7 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v8 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v15 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v16 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor",
                    "jira-planner-connection"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v12 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v22 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v25 = [
        {
            "alias": "currentPage",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ 
        },
        "params": {
            "cacheID": "661233a47ecadf36bf6b55db313a301e",
            "id": "606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9",
            "metadata": {},
            "name": "PageTreeQuery",
            "operationKind": "query",
            "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$b0adf32477ccbbfa$var$node.hash = "f7e2a69b86e03d256ceaf9a0f482bed1";
var $b0adf32477ccbbfa$export$2e2bcd8739ae039 = $b0adf32477ccbbfa$var$node;
module.exports["default"] = $b0adf32477ccbbfa$export$2e2bcd8739ae039;

});

parcelRegister("8jDil", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/page/manifest.ts
var $60de943ef043ed79$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $60de943ef043ed79$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $60de943ef043ed79$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("aR3ec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Only the everything mode proceeds to data preloading.
        if (preloadOptions?.preloadingMode !== "everything") return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<cc3649e97b9be1d6269151089c18fb3f>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("l1uFv", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $jclGA = parcelRequire("jclGA");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Cache reads stay native to the selected route. The cache bridge only
    // mirrors successful writes/results into the other cache.
    return $65c7b8940c778902$var$readQueryInteropOriginal(params, source);
}
function $65c7b8940c778902$var$readQueryInteropOriginal(params, source) {
    return source === 'relay' ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : (0, $jclGA.cloneRelayQueryResult)(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("iMZH0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2f90348ffd0aefc186c142725e2cedf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dadc90963697fdad$var$_react = $dadc90963697fdad$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dadc90963697fdad$var$_iconNew = $dadc90963697fdad$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $dadc90963697fdad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/sync
 * Usage guidance:
 * Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dadc90963697fdad$var$SyncIcon = (props)=>/*#__PURE__*/ $dadc90963697fdad$var$_react.default.createElement($dadc90963697fdad$var$_iconNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$dadc90963697fdad$var$SyncIcon.displayName = 'SyncIcon';
var $dadc90963697fdad$var$_default = module.exports.default = $dadc90963697fdad$var$SyncIcon;

});

parcelRegister("1bRPL", function(module, exports) {

var $dJ9DS = parcelRequire("dJ9DS");


var $fYxCA = parcelRequire("fYxCA");


var $beJwy = parcelRequire("beJwy");

function $c244e860353a6e68$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $fYxCA.isSafariOnIOS)() || (0, $dJ9DS.isAndroid)()) return (0, $beJwy.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $c244e860353a6e68$export$427e20518819fabc;

});

parcelRegister("fYxCA", function(module, exports) {

var $gEZCs = parcelRequire("gEZCs");


var $kc8B9 = parcelRequire("kc8B9");

const $e0d278f731546dca$export$52fc40c68fea4952 = (0, $gEZCs.once)(function isSafariOnIOS() {
    return (0, $kc8B9.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $e0d278f731546dca$export$52fc40c68fea4952;

});

parcelRegister("beJwy", function(module, exports) {
const $d5bf326c593d3c52$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $d5bf326c593d3c52$export$81d8e72a15eef435;

});

parcelRegister("deUyp", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $kc8B9 = parcelRequire("kc8B9");


var $f0WuI = parcelRequire("f0WuI");


var $7nhOg = parcelRequire("7nhOg");


var $fbx9a = parcelRequire("fbx9a");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $0a7192879c73e22c$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $0a7192879c73e22c$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $0a7192879c73e22c$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $fbx9a.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $fbx9a.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $7nhOg.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f0WuI.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $fbx9a.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $kc8B9.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $4Vdlk.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $0a7192879c73e22c$export$52d889c66db0f96e;

});

parcelRegister("7jfHQ", function(module, exports) {
const $dc3179d69ab4f7dc$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
module.exports["getObjectIconUrl"] = $dc3179d69ab4f7dc$export$bcf275804417edda;

});

parcelRegister("vZEJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $cVoAa = parcelRequire("cVoAa");


var $hHzd2 = parcelRequire("hHzd2");

const $b399db01e99f7201$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, edge: edge, gap: gap, indent: indent, type: type } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== edge || $[1] !== gap || $[2] !== indent || $[3] !== t2 || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
            edge: edge,
            gap: gap,
            strokeColor: t2,
            type: type,
            indent: indent
        });
        $[0] = edge;
        $[1] = gap;
        $[2] = indent;
        $[3] = t2;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
};
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b399db01e99f7201$export$2e2bcd8739ae039 = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["default"] = $b399db01e99f7201$export$2e2bcd8739ae039;

});

parcelRegister("cVoAa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $06f7f86bfd55e0d2$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $06f7f86bfd55e0d2$var$baseStyles = {
    root: "_3iDTPbvLZJ _1mT5xdWVPG _42Yu6B7dHp _1pp6NdYbGa _0KLXrul0Q1 _1Oimfu715P _0eGJOxOn88 _1nRsHk6wH8 _2KinTkl0Q1 _0OU75rKWn1 _3Ku51Iogpp _3dCYwDWVPG _2DsrY12Njc _3ScelF3U6W _1lBcDc3U6W"
};
const $06f7f86bfd55e0d2$var$orientationStyles = {
    horizontal: "_0jFU0VOn88 _3iC0zdfRAD _1OKFqYdnbC _2jTvwtWjDq",
    vertical: "_39xV02On88 _2IhTonfRAD _0Bm75GdnbC _35I30BWjDq"
};
const $06f7f86bfd55e0d2$var$edgeStyles = {
    top: "_2IhTon5Cwg _35I30BHqe5",
    right: "_4ApkO25Cwg _1D2b5MHqe5",
    bottom: "_0Bm75G5Cwg _31ReDyHqe5",
    left: "_3OE6xY5Cwg _1L3m71Hqe5"
};
const $06f7f86bfd55e0d2$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
const $06f7f86bfd55e0d2$export$17d680238e50603e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Line(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { edge: edge, gap: t1, indent: t2, strokeColor: t3, strokeWidth: t4, type: t5 } = t0;
    const gap = t1 === undefined ? "0px" : t1;
    const indent = t2 === undefined ? "0px" : t2;
    const strokeColor = t3 === undefined ? (0, $hHzd2.presetStrokeColors).default : t3;
    const strokeWidth = t4 === undefined ? (0, $hHzd2.presetStrokeWidth) : t4;
    const type = t5 === undefined ? "terminal" : t5;
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    const t6 = `calc(-0.5 * (${gap} + var(--stroke-width)))`;
    let t7;
    if ($[0] !== indent || $[1] !== type) {
        t7 = $06f7f86bfd55e0d2$var$lineStartFrom[type]({
            indent: indent
        });
        $[0] = indent;
        $[1] = type;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = type === "no-terminal" ? "none" : "block";
    let t9;
    if ($[3] !== strokeColor || $[4] !== strokeWidth || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--main-axis-offset": t6,
            "--line-main-axis-start": t7,
            "--terminal-display": t8,
            "--terminal-diameter": "calc(var(--stroke-width) * 4)",
            "--terminal-radius": "calc(var(--terminal-diameter) / 2)",
            "--terminal-main-axis-start": "calc(-1 * var(--terminal-diameter))",
            "--terminal-cross-axis-offset": "calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)"
        };
        $[3] = strokeColor;
        $[4] = strokeWidth;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = t9;
    const t11 = $06f7f86bfd55e0d2$var$orientationStyles[orientation];
    const t12 = $06f7f86bfd55e0d2$var$edgeStyles[edge];
    let t13;
    if ($[9] !== t11 || $[10] !== t12) {
        t13 = (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            t11,
            t12
        ]);
        $[9] = t11;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== t10 || $[13] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t10,
            className: t13
        });
        $[12] = t10;
        $[13] = t13;
        $[14] = t14;
    } else t14 = $[14];
    return t14;
} : function Line({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $06f7f86bfd55e0d2$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            $06f7f86bfd55e0d2$var$orientationStyles[orientation],
            $06f7f86bfd55e0d2$var$edgeStyles[edge]
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$06f7f86bfd55e0d2$export$2e2bcd8739ae039 = $06f7f86bfd55e0d2$export$17d680238e50603e;
module.exports["Line"] = $06f7f86bfd55e0d2$export$17d680238e50603e;

});

parcelRegister("hHzd2", function(module, exports) {
const $4ee2c7f82a7b207c$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $4ee2c7f82a7b207c$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $4ee2c7f82a7b207c$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $4ee2c7f82a7b207c$export$45db03aa04b685e3;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fa619d4dc0abdbd4993ef2902e26740>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_iconNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/file-markdown
 * Usage guidance:
 * Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_iconNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e8b2cdb4a7b2569268a3fe6ec068354>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_iconNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/notepad
 * Usage guidance:
 * Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_iconNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5tsXU = parcelRequire("5tsXU");


var $hT3jf = parcelRequire("hT3jf");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) {
        let t3;
        if ($[4] !== color) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
                label: "",
                size: "small",
                color: color,
                testId: "icons.content-icon.label.managed-folder"
            });
            $[4] = color;
            $[5] = t3;
        } else t3 = $[5];
        return t3;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[6] !== Icon || $[7] !== color || $[8] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[6] = Icon;
        $[7] = color;
        $[8] = label.id;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
        label: "",
        size: "small",
        color: color,
        testId: "icons.content-icon.label.managed-folder"
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("jXuVu"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("jXuVu", function(module, exports) {

let $e87b845248feaf56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e87b845248feaf56$var$load("kGnv3"),
    $e87b845248feaf56$var$load("kPpF9"),
    $e87b845248feaf56$var$load("cBeoH"),
    $e87b845248feaf56$var$load("lN9TX"),
    $e87b845248feaf56$var$load("gFeoL"),
    $e87b845248feaf56$var$load("6wr18"),
    $e87b845248feaf56$var$load("iNbHV"),
    $e87b845248feaf56$var$load("ffEVr"),
    $e87b845248feaf56$var$load("4Ldt2"),
    $e87b845248feaf56$var$load("5gsbh"),
    $e87b845248feaf56$var$load("hsRa9"),
    $e87b845248feaf56$var$load("bEleE"),
    $e87b845248feaf56$var$load("8OeKT"),
    $e87b845248feaf56$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("5tsXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $3216f3fcd316d4ef$export$75f34eec99819e9c = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderClosedIcon"] = $3216f3fcd316d4ef$export$75f34eec99819e9c;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("1FFRr", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $79D42 = parcelRequire("79D42");


var $gGzL7 = parcelRequire("gGzL7");


var $jG16D = parcelRequire("jG16D");

/** Used as the size to enable large array optimizations. */ var $137a177bdcb6c988$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $137a177bdcb6c988$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $gqaVn, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $79D42(values, $gGzL7(iteratee));
    if (comparator) {
        includes = $3wyDU;
        isCommon = false;
    } else if (values.length >= $137a177bdcb6c988$var$LARGE_ARRAY_SIZE) {
        includes = $jG16D;
        isCommon = false;
        values = new $dLza3(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $137a177bdcb6c988$var$baseDifference;

});

parcelRegister("g6KTr", function(module, exports) {

var $cchFE = parcelRequire("cchFE");

let $2b230915474122a8$var$node = null;
const $2b230915474122a8$var$size = '1px';
const $2b230915474122a8$var$visuallyHiddenStyles = {
    // Standard visually hidden styles.
    // Copied from our VisuallyHidden (react) package.
    width: $2b230915474122a8$var$size,
    height: $2b230915474122a8$var$size,
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: `rect(${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size}, ${$2b230915474122a8$var$size})`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    // Pulling upwards slightly to prevent the page
    // from growing when appended to a body that contains
    // an element with height:100%
    marginTop: `-${$2b230915474122a8$var$size}`,
    // Just being safe and letting this element not interfere with hitboxes
    pointerEvents: 'none'
};
/**
 * Creates a live region node, appends it to the body, and returns it.
 */ function $2b230915474122a8$var$createNode() {
    const node = document.createElement('div');
    /**
   * Using `role="status"` instead of `role="alert"` so that the message
   * can be queued and read when able.
   *
   * We found with `role="alert"` the message was not reliably read when
   * focus changed.
   */ node.setAttribute('role', 'status');
    Object.assign(node.style, $2b230915474122a8$var$visuallyHiddenStyles);
    document.body.append(node);
    return node;
}
/**
 * Returns the live region node, creating one if necessary.
 */ function $2b230915474122a8$var$getNode() {
    if ($2b230915474122a8$var$node === null) $2b230915474122a8$var$node = $2b230915474122a8$var$createNode();
    return $2b230915474122a8$var$node;
}
let $2b230915474122a8$var$timerId = null;
function $2b230915474122a8$var$tryClearTimer() {
    if ($2b230915474122a8$var$timerId !== null) clearTimeout($2b230915474122a8$var$timerId);
    $2b230915474122a8$var$timerId = null;
}
function $2b230915474122a8$export$a9b970dcc4ae71a9(message) {
    /**
   * Calling this immediately to ensure a node exists and has time to be parsed
   * and exposed in the accessibility tree.
   */ $2b230915474122a8$var$getNode();
    /**
   * Updating the message in a timeout so that it's less likely to be interrupted.
   *
   * This function is often called right before focus changes,
   * because the user has just taken an action.
   * This focus change would often cause the message to be skipped / interrupted.
   */ $2b230915474122a8$var$tryClearTimer();
    $2b230915474122a8$var$timerId = setTimeout(()=>{
        $2b230915474122a8$var$timerId = null;
        const node = $2b230915474122a8$var$getNode();
        node.textContent = message;
    }, (0, $cchFE.announceDelay));
    return;
}
function $2b230915474122a8$export$de863c629cb9919d() {
    $2b230915474122a8$var$tryClearTimer();
    $2b230915474122a8$var$node?.remove();
    $2b230915474122a8$var$node = null;
}
module.exports["announce"] = $2b230915474122a8$export$a9b970dcc4ae71a9;
module.exports["cleanup"] = $2b230915474122a8$export$de863c629cb9919d;

});

parcelRegister("cchFE", function(module, exports) {
/**
 * Delay until the text content of the live region is updated.
 *
 * This value was reached through some experimentation, and may need tweaking in the future.
 */ const $714f0bc45b620f55$export$a88f30567ea7367a = 1000;
module.exports["announceDelay"] = $714f0bc45b620f55$export$a88f30567ea7367a;

});

parcelRegister("9AuSX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $guH5C = parcelRequire("guH5C");


var $hHzd2 = parcelRequire("hHzd2");

const $471650b8def160c1$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { appearance: t1, indent: indent } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== indent || $[1] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $guH5C.Border), {
            strokeColor: t2,
            indent: indent
        });
        $[0] = indent;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $guH5C.Border), {
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        indent: indent
    });
};
var // For React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$471650b8def160c1$export$2e2bcd8739ae039 = $471650b8def160c1$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $471650b8def160c1$export$62ed72bc21f6b8a6;

});

parcelRegister("guH5C", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $ff42c94e2588d608$var$styles = null;
const $ff42c94e2588d608$export$d8e9c9d63e86d41e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Border(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { strokeColor: t1, strokeWidth: t2, borderRadius: t3, indent: t4 } = t0;
    const strokeColor = t1 === undefined ? (0, $hHzd2.presetStrokeColors).default : t1;
    const strokeWidth = t2 === undefined ? (0, $hHzd2.presetStrokeWidth) : t2;
    const borderRadius = t3 === undefined ? "3px" : t3;
    const indent = t4 === undefined ? "0px" : t4;
    let t5;
    if ($[0] !== borderRadius || $[1] !== indent || $[2] !== strokeColor || $[3] !== strokeWidth) {
        t5 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--border-radius": borderRadius,
            "--indent": indent
        };
        $[0] = borderRadius;
        $[1] = indent;
        $[2] = strokeColor;
        $[3] = strokeWidth;
        $[4] = t5;
    } else t5 = $[4];
    const t6 = t5;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_30huDKTp3k _0bjKvDY715 _1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _1OKFqYdnbC _3iC0zd3NlV _1pp6NdYbGa"
        ]);
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== t6) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t6,
            className: t7
        });
        $[6] = t6;
        $[7] = t8;
    } else t8 = $[7];
    return t8;
} : function Border({ strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $hekY6.default)([
            "_30huDKTp3k _0bjKvDY715 _1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _1OKFqYdnbC _3iC0zd3NlV _1pp6NdYbGa"
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ff42c94e2588d608$export$2e2bcd8739ae039 = $ff42c94e2588d608$export$d8e9c9d63e86d41e;
module.exports["Border"] = $ff42c94e2588d608$export$d8e9c9d63e86d41e;

});

parcelRegister("8SiaH", function(module, exports) {

var $4qoOj = parcelRequire("4qoOj");

function $9b6a08e7b6b87fbc$export$3f55479a3469259f(isEqual = (0, $4qoOj.isShallowEqual)) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}
module.exports["stable"] = $9b6a08e7b6b87fbc$export$3f55479a3469259f;

});

parcelRegister("4qoOj", function(module, exports) {
function $cfd4043bf39448ea$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
module.exports["isShallowEqual"] = $cfd4043bf39448ea$export$2225b4c39d37f8b3;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("kRW4Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $kNIYN.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).HOME.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("4pQus", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");


var $j6gAQ = parcelRequire("j6gAQ");


var $kxLmQ = parcelRequire("kxLmQ");


var $1Rned = parcelRequire("1Rned");


var $5RsFr = parcelRequire("5RsFr");


var $gO1os = parcelRequire("gO1os");

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ var $337236ac63717ee3$var$unionBy = $kxLmQ(function(arrays) {
    var iteratee = $gO1os(arrays);
    if ($5RsFr(iteratee)) iteratee = undefined;
    return $1Rned($avFJ9(arrays, 1, $5RsFr, true), $j6gAQ(iteratee, 2));
});
module.exports = $337236ac63717ee3$var$unionBy;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("51Cpe", function(module, exports) {

var $1zKNa = parcelRequire("1zKNa");

function $a967676111a2617d$export$c8ffecbe249dc8f8(userData) {
    return userData[0, $1zKNa.uniqueKey] ?? null;
}
module.exports["extractInstruction"] = $a967676111a2617d$export$c8ffecbe249dc8f8;

});

parcelRegister("1zKNa", function(module, exports) {


const $df2368b2d8ac02d6$export$4032e2468b38573b = Symbol('tree-item-instruction');
module.exports["uniqueKey"] = $df2368b2d8ac02d6$export$4032e2468b38573b;

});

parcelRegister("8NIRB", function(module, exports) {

var $4qoOj = parcelRequire("4qoOj");


var $8SiaH = parcelRequire("8SiaH");


var $1zKNa = parcelRequire("1zKNa");

function $bde667eabeeced2a$var$getCenter(rect) {
    return {
        x: (rect.right + rect.left) / 2,
        y: (rect.bottom + rect.top) / 2
    };
}
function $bde667eabeeced2a$var$standardHitbox({ client: client, borderBox: borderBox }) {
    const quarterOfHeight = borderBox.height / 4;
    // In the top 1/4: reorder-above
    // On the line = in the top 1/4 to give this zone a bit more space
    if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
    // In the bottom 1/4: reorder-below
    // On the line = in the bottom 1/4 to give this zone a bit more space
    if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
    return 'make-child';
}
function $bde667eabeeced2a$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    if (mode === 'standard') {
        const type = $bde667eabeeced2a$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            type: type,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    const center = $bde667eabeeced2a$var$getCenter(borderBox);
    if (mode === 'expanded') {
        // leveraging "standard" hitbox to ensure that the 'reorder-above' hit zone is
        // exactly the same for "standard" and "expanded" items
        const type = $bde667eabeeced2a$var$standardHitbox({
            borderBox: borderBox,
            client: client
        });
        return {
            // Use the "standard" hitbox for "reorder above",
            // The rest of the item is "make-child"
            type: type === 'reorder-above' ? type : 'make-child',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // `mode` is "last-in-group"
    const visibleInset = indentPerLevel * currentLevel;
    // Before the left edge of the visible item
    if (client.x < borderBox.left + visibleInset) {
        // Above the center: `reorder-above`
        if (client.y < center.y) return {
            type: 'reorder-above',
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
        // On or below the center: `reparent`
        // On the center = `reparent` as we are giving a slightly bigger hitbox to this
        // action as it is the only place a user can do it
        const rawLevel = (client.x - borderBox.left) / indentPerLevel;
        // We can get sub pixel negative numbers as getBoundingClientRect gives sub-pixel accuracy,
        // where as clientX is rounded to the nearest pixel.
        // Using Math.max() ensures we can never get a negative level
        const desiredLevel = Math.max(Math.floor(rawLevel), 0);
        return {
            type: 'reparent',
            desiredLevel: desiredLevel,
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    // On the visible item
    return {
        type: $bde667eabeeced2a$var$standardHitbox({
            borderBox: borderBox,
            client: client
        }),
        indentPerLevel: indentPerLevel,
        currentLevel: currentLevel
    };
}
function $bde667eabeeced2a$var$areInstructionsEqual(a, b) {
    // Shortcut
    if (a.type !== b.type) return false;
    if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $bde667eabeeced2a$var$areInstructionsEqual(a.desired, b.desired);
    return (0, $4qoOj.isShallowEqual)(a, b);
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $bde667eabeeced2a$var$memoizeInstruction = (0, $8SiaH.stable)($bde667eabeeced2a$var$areInstructionsEqual);
function $bde667eabeeced2a$var$applyInstructionBlock({ desired: desired, block: block }) {
    if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
        const blocked = {
            type: 'instruction-blocked',
            desired: desired
        };
        return blocked;
    }
    return desired;
}
function $bde667eabeeced2a$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
    const desired = $bde667eabeeced2a$var$getInstruction(rest);
    const withBlock = $bde667eabeeced2a$var$applyInstructionBlock({
        desired: desired,
        block: block
    });
    const memoized = $bde667eabeeced2a$var$memoizeInstruction(withBlock);
    return {
        ...userData,
        [(0, $1zKNa.uniqueKey)]: memoized
    };
}
module.exports["attachInstruction"] = $bde667eabeeced2a$export$267ad49d812c2c7f;

});

parcelRegister("fl787", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $9AuSX = parcelRequire("9AuSX");


var $vZEJe = parcelRequire("vZEJe");

function $7e3cbdcdf868d423$var$getElement({ instruction: instruction, isBlocked: isBlocked }) {
    const indent = `${instruction.currentLevel * instruction.indentPerLevel}px`;
    const appearance = isBlocked ? 'warning' : 'default';
    if (instruction.type === 'reorder-above') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
        edge: "top",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reorder-below') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
        edge: "bottom",
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'make-child') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9AuSX.DropIndicator), {
        appearance: appearance,
        indent: indent
    });
    if (instruction.type === 'reparent') {
        const reparentIndent = `${instruction.desiredLevel * instruction.indentPerLevel}px`;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
            edge: "bottom",
            appearance: appearance,
            indent: reparentIndent
        });
    }
    return null;
}
function $7e3cbdcdf868d423$export$62ed72bc21f6b8a6({ instruction: instruction }) {
    if (instruction.type === 'instruction-blocked') return $7e3cbdcdf868d423$var$getElement({
        instruction: instruction.desired,
        isBlocked: true
    });
    return $7e3cbdcdf868d423$var$getElement({
        instruction: instruction,
        isBlocked: false
    });
}
module.exports["DropIndicator"] = $7e3cbdcdf868d423$export$62ed72bc21f6b8a6;

});

parcelRegister("6p02T", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?/[\]_\-+=`~|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("dYA5q", function(module, exports) {
/* LivePagePreloader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $39rFu = parcelRequire("39rFu");

const $15ad27b3337f3f82$var$logger = (0, $7W8i8.getLogger)('LivePagePreloader');
const $15ad27b3337f3f82$export$6eca3633b04cd128 = ({ isLivePage: isLivePage, children: children })=>{
    const { livePageComponentsPreloader: livePageComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const [isPreloading, setIsPreloading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isPreloading || !isLivePage) return;
        const preloadComponents = ()=>{
            livePageComponentsPreloader?.().catch((error)=>{
                $15ad27b3337f3f82$var$logger.error`Preloading live page components failed ${error}`;
            }).finally(()=>{
                setIsPreloading(false);
            });
        };
        preloadComponents();
    }, [
        isPreloading,
        isLivePage,
        livePageComponentsPreloader
    ]);
    const triggerPreload = (0, $cozmU.useCallback)(()=>{
        if (isLivePage && !isPreloading) setIsPreloading(true);
    }, [
        isLivePage,
        isPreloading
    ]); // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    if (!isLivePage || !(0, $9wGTI.fg)('confluence_perf_preload_livepage_assets')) return children;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box // presentation role here to tell screen readers that this is not interactive
    ), {
        role: "presentation",
        onMouseEnter: triggerPreload,
        onFocus: triggerPreload,
        xcss: (0, $w6R6I.cx)($15ad27b3337f3f82$var$styles.box)
    }, children);
};
const $15ad27b3337f3f82$var$styles = {
    box: "_0jFU0VN91d _39xV02N91d"
};
module.exports["LivePagePreloader"] = $15ad27b3337f3f82$export$6eca3633b04cd128;

});

parcelRegister("iSXh4", function(module, exports) {

var $9VdrT = parcelRequire("9VdrT");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $9VdrT.default);
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        },
        __callerPackage__: "automated-meeting-notes"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("9VdrT", function(module, exports) {
/**
 * @generated SignedSource<<c55748e87ec72b47f4575a0869b376cf>>
 * @relayHash 2d27dcc1d1eac2731f01ec3e79c7f7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd
const $2aa10c7c748cb29a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2d27dcc1d1eac2731f01ec3e79c7f7d9",
            "id": "bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd",
            "metadata": {},
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$2aa10c7c748cb29a$var$node.hash = "a7e1d622b5e3dfb0202b4f6045de22bd";
var $2aa10c7c748cb29a$export$2e2bcd8739ae039 = $2aa10c7c748cb29a$var$node;
module.exports["default"] = $2aa10c7c748cb29a$export$2e2bcd8739ae039;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$a90803a9f656fd5f = 'showCreateWithRovo';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$57f29eb0a90c2092 = 'initial-background-style';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$bc2f90c007ecd529 = 'rovo';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["SHOW_CREATE_WITH_ROVO_QUERY_PARAM"] = $0037b6bfd6daf741$export$a90803a9f656fd5f;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["INITIAL_BACKGROUND_STYLE_QUERY_PARAM"] = $0037b6bfd6daf741$export$57f29eb0a90c2092;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["ROVO_PARENT_PRODUCT_QUERY_VALUE"] = $0037b6bfd6daf741$export$bc2f90c007ecd529;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("LSims", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $450638ee7a6e2e59$export$ec80b976b56288ba = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $aJUpe.default), {
        variables: {
            contentId: contentId ?? '',
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)
        },
        fetchPolicy: 'cache-only',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
        __callerPackage__: "content-markdown-mode"
    });
    return (0, $4Pmcr.getIsMarkdownModeFromData)(data);
};
module.exports["useIsMarkdownMode"] = $450638ee7a6e2e59$export$ec80b976b56288ba;

});

parcelRegister("aJUpe", function(module, exports) {
/**
 * @generated SignedSource<<97f042394447b34381d2572432982113>>
 * @relayHash 8ee1f0cde2475ae17a8f029f978204ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971
const $1180c416e2ce3051$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isMarkdownModeEnabled"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isMarkdownModeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isMarkdownMode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ee1f0cde2475ae17a8f029f978204ad",
            "id": "1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971",
            "metadata": {},
            "name": "IsMarkdownModeQuery",
            "operationKind": "query",
            "text": "query IsMarkdownModeQuery($contentId:ID!,$isMarkdownModeEnabled:Boolean=false){content(id:$contentId){nodes{id,contentProperties{latest{isMarkdownMode@include(if:$isMarkdownModeEnabled)}}}}}"
        }
    };
}();
$1180c416e2ce3051$var$node.hash = "65f92bc360aa57691987c1aba7d545ca";
var $1180c416e2ce3051$export$2e2bcd8739ae039 = $1180c416e2ce3051$var$node;
module.exports["default"] = $1180c416e2ce3051$export$2e2bcd8739ae039;

});

parcelRegister("4Pmcr", function(module, exports) {
const $70bbf1741b7230f7$export$6bc4ac71fcf3f02a = (data)=>{
    return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
module.exports["getIsMarkdownModeFromData"] = $70bbf1741b7230f7$export$6bc4ac71fcf3f02a;

});

parcelRegister("kSPGK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $bDgLe.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $cozmU.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("4NX9d", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $cozmU.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("dd6Gw", function(module, exports) {
// This type matches the GraphQL result from fetching something with `properties`.
const $411dffa4c6a383d3$export$9f5d37e817ec8d6 = (page)=>{
    const editorProperty = page?.properties?.nodes?.find((prop)=>prop?.key === 'editor');
    const editorVersion = (editorProperty?.value || '').replace(/['"]+/g, '');
    if (editorVersion !== 'v1' && editorVersion !== 'v2') return '';
    else return editorVersion;
};
module.exports["getEditorVersionFromPageProperties"] = $411dffa4c6a383d3$export$9f5d37e817ec8d6;

});

parcelRegister("4K4h4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await (parcelRequire("gSu53"))).ContentTreeIcon
});
module.exports["ContentTreeIconLoader"] = $61f85e63c6992485$export$e511f243d20dd25e;

});

parcelRegister("gSu53", function(module, exports) {

let $c49905dc6f37c0aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c49905dc6f37c0aa$var$load("6wr18"),
    $c49905dc6f37c0aa$var$load("ffEVr"),
    $c49905dc6f37c0aa$var$load("YfZEx")
]).then(()=>parcelRequire('iU0gR'));

});

parcelRegister("6bZDi", function(module, exports) {
const $a8768b1a0c8c67c8$export$ee7a362b3ed8b036 = [
    'page',
    'whiteboard',
    'database',
    'slide',
    'folder',
    'liveDoc'
];
const $a8768b1a0c8c67c8$export$a73714094b2817b7 = (obj)=>typeof obj === 'string' && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(obj);
const $a8768b1a0c8c67c8$export$204659eac14d740b = (obj)=>$a8768b1a0c8c67c8$export$a73714094b2817b7(obj) ? obj : undefined;
const $a8768b1a0c8c67c8$export$c7c48cc42c0546b7 = (contentType)=>{
    const contentTreeType = $a8768b1a0c8c67c8$export$204659eac14d740b(contentType);
    return !!contentTreeType && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(contentTreeType);
};
module.exports["isContentTreeType"] = $a8768b1a0c8c67c8$export$a73714094b2817b7;
module.exports["toContentTreeType"] = $a8768b1a0c8c67c8$export$204659eac14d740b;
module.exports["includesValidContentTreeType"] = $a8768b1a0c8c67c8$export$c7c48cc42c0546b7;

});

parcelRegister("a6VRS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) open folder.
 * Renders an open folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $6b5b62a1c1d5201a$export$d5c72b0cf938803f = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.31055 2.75H12C13.1046 2.75 14 3.64543 14 4.75V6H14.6599C15.5809 6 16.2416 6.88783 15.9771 7.77002L15.3081 10H13.7419L14.4919 7.5H4.55811L2.75806 13.5H10V15H1.75C0.783502 15 0 14.2165 0 13.25V3C0 1.89543 0.895431 1 2 1H5.56055L7.31055 2.75ZM2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V12.4731L3.14795 6.97998C3.32243 6.39838 3.85788 6 4.46509 6H12.5V4.75C12.5 4.47386 12.2761 4.25 12 4.25H6.68945L4.93945 2.5H2Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderOpenIcon"] = $6b5b62a1c1d5201a$export$d5c72b0cf938803f;

});

parcelRegister("2vuKf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $kBr4q.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $kBr4q.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $kBr4q.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("ayS0g", function(module, exports) {
$parcel$export(module.exports, "PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY);
$parcel$export(module.exports, "IS_NEW_EMBED_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).IS_NEW_EMBED_QUERY_PARAM_KEY);
$parcel$export(module.exports, "DotGridBackground", () => (parcelRequire("fnyki")).DotGridBackground);
$parcel$export(module.exports, "normalizeAndValidateUrl", () => (parcelRequire("aVk5V")).normalizeAndValidateUrl);
$parcel$export(module.exports, "fetchDataFromORS", () => (parcelRequire("laZ2J")).fetchDataFromORS);
$parcel$export(module.exports, "useFetchDataFromORS", () => (parcelRequire("laZ2J")).useFetchDataFromORS);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $5y1g5 = parcelRequire("5y1g5");


var $fnyki = parcelRequire("fnyki");


var $l01bG = parcelRequire("l01bG");


var $9QoCS = parcelRequire("9QoCS");


var $aVk5V = parcelRequire("aVk5V");


var $laZ2J = parcelRequire("laZ2J");


var $eaBPu = parcelRequire("eaBPu");


});

parcelRegister("5y1g5", function(module, exports) {
const $a7a321c00b90eef4$export$387a295dc04f5f90 = 'showPermissionsBanner';
const $a7a321c00b90eef4$export$3738b9a85a6948a6 = 'isNewBlankEmbed';
module.exports["PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$387a295dc04f5f90;
module.exports["IS_NEW_EMBED_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$3738b9a85a6948a6;

});

parcelRegister("fnyki", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");

const $f37f7bd9b125a5e3$var$fullHeightContainer = (0, $buxP3.xcss)({
    height: 'calc(100vh - var(--bannerHeight, 0px) - var(--topNavigationHeight, 0px))'
});
const $f37f7bd9b125a5e3$var$dotGridBackground = (0, $buxP3.xcss)({
    backgroundImage: `radial-gradient(circle at 2px 2px, ${"var(--ds-surface-overlay-hovered, #F0F1F2)"} 2px, transparent 0)`,
    backgroundSize: '20px 20px'
});
const $f37f7bd9b125a5e3$export$b520b551d14c6a6e = ({ showDottedBackground: showDottedBackground, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: [
            $f37f7bd9b125a5e3$var$fullHeightContainer,
            showDottedBackground && $f37f7bd9b125a5e3$var$dotGridBackground
        ]
    }, children);
};
module.exports["DotGridBackground"] = $f37f7bd9b125a5e3$export$b520b551d14c6a6e;

});

parcelRegister("l01bG", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $f493076f7b61f977$export$b8af48de83cf2008 = (url)=>{
    const httpPattern = /^https?:\/\/[^\s]*$/im;
    return httpPattern.test(url);
};
const $f493076f7b61f977$export$285f8e8582d94002 = (data)=>{
    /*
	 * data.generator.icon.url is where provider icon is and
	 * data.icon.url is where the link icon usually is. In most cases,
	 * they are the same thing but some providers have specific icons
	 * for specific links. For example, a Google Sheet link from
	 * google-object-provider would return Google Drive icon as a provider
	 * icon (data.generator.icon.url) but would return Google Sheets icon
	 * as link icon (data.icon.url).
	 */ const generatorIconObj = data.generator?.icon;
    const iconObj = data.icon;
    const generatorIcon = generatorIconObj && (0, $2GG3F.extractUrlFromIconJsonLd)(generatorIconObj) || '';
    const icon = iconObj && (0, $2GG3F.extractUrlFromIconJsonLd)(iconObj) || '';
    // TEMP: calling isValidScheme here is a workaround to
    // ensure data URIs for favicons don't make it through
    // (BE fails as it expects a http(s) scheme). Long term,
    // we should support inlined data URI favicons.
    // https://hello.jira.atlassian.cloud/browse/CTIA-1918
    return $f493076f7b61f977$export$b8af48de83cf2008(icon) && icon || $f493076f7b61f977$export$b8af48de83cf2008(generatorIcon) && generatorIcon || '';
};
module.exports["extractIconUrl"] = $f493076f7b61f977$export$285f8e8582d94002;

});

parcelRegister("9QoCS", function(module, exports) {

var $2A177 = parcelRequire("2A177");

// Gets a more specific product for the URL if we know that a provider can cover
// multiple products
const $9b10c9a9aeeff07b$var$getSpecificProduct = (hostname, providerName)=>{
    if (providerName === 'OneDrive' && hostname.includes('sharepoint')) return 'SharePoint';
    else return providerName;
};
const $9b10c9a9aeeff07b$export$a6859be1cfc01481 = (embedUrl, data)=>{
    const url = new URL(embedUrl);
    const urlHostname = url.hostname;
    // we want to remove the "www." at the beginning of the URL if it exists
    // so that the analytics are receiving domains in a consistent format
    const parsedHostname = urlHostname.replace(/^www\./, '');
    if (!data) return parsedHostname;
    const provider = (0, $2A177.extractProvider)(data);
    const providerName = provider?.text;
    const embedProduct = $9b10c9a9aeeff07b$var$getSpecificProduct(urlHostname, providerName);
    const providerIsHostname = embedProduct !== undefined && embedProduct.includes(parsedHostname);
    // ORS will sometimes return the urlHostname as the provider so use
    // the parsedHostname is there is no providerName or if the provider
    // contains the hostname
    if (!embedProduct || providerIsHostname) return parsedHostname;
    return embedProduct;
};
module.exports["extractProduct"] = $9b10c9a9aeeff07b$export$a6859be1cfc01481;

});

parcelRegister("aVk5V", function(module, exports) {

var $imtNr = parcelRequire("imtNr");

var $e6CqH = parcelRequire("e6CqH");

// regex to check that the url entered is at least of this format "://example.com"
const $9509ca2c76fbd4db$var$REGEX = /:\/\/(.*\.)?.+\..+/;
const $9509ca2c76fbd4db$export$53289a1e3dd02563 = (url)=>{
    const normalizedUrl = (0, $e6CqH.normalizeUrl)(url.trim());
    // `isSafeUrl()` treats a string with just the protocol (e.g. "http://") as a valid url so we need additional check
    const isValid = !!normalizedUrl && (0, $imtNr.isSafeUrl)(normalizedUrl) && $9509ca2c76fbd4db$var$REGEX.test(normalizedUrl);
    return isValid ? normalizedUrl : null;
};
module.exports["normalizeAndValidateUrl"] = $9509ca2c76fbd4db$export$53289a1e3dd02563;

});

parcelRegister("laZ2J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bI14T = parcelRequire("bI14T");


var $jMcHR = parcelRequire("jMcHR");


var $jqhMF = parcelRequire("jqhMF");


var $9DHhW = parcelRequire("9DHhW");


var $l01bG = parcelRequire("l01bG");


var $aUoHg = parcelRequire("aUoHg");


var $eaBPu = parcelRequire("eaBPu");

const $07e4518f8509fec5$var$extractEmbedData = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    return {
        iconURL: data ? (0, $l01bG.extractIconUrl)(data) : undefined,
        product: (0, $eaBPu.extractEmbedProduct)({
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            data: data
        }),
        title: data ? (0, $jqhMF.extractTitle)(data) : undefined,
        url: data ? (0, $jMcHR.extractLink)(data) : undefined
    };
};
const $07e4518f8509fec5$export$7053598ec03d6366 = async ({ cardClient: cardClient, createAnalyticsEvent: createAnalyticsEvent, embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
    try {
        const details = await cardClient.fetchData(embedUrl);
        let data = details && details.data;
        let meta = details && details.meta;
        if (includeAuthHandling) {
            const authURL = meta.auth?.[0]?.url;
            if (meta.access === 'unauthorized' && authURL) {
                try {
                    await (0, $aUoHg.handleEmbedAuthentication)({
                        authURL: authURL
                    });
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'outboundAuthFlow',
                            source: 'smartLinkEmbedAuthentication',
                            attributes: {
                                error: error.type || 'unknown',
                                extensionKey: meta?.key ?? null,
                                destinationObjectType: meta?.resourceType ?? null,
                                contentType: 'embed'
                            },
                            nonPrivacySafeAttributes: {
                                linkDomain: (0, $eaBPu.extractEmbedProduct)({
                                    createAnalyticsEvent: createAnalyticsEvent,
                                    data: data,
                                    embedUrl: embedUrl
                                })
                            }
                        }
                    }).fire();
                    return {
                        data: data,
                        meta: meta,
                        parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                            createAnalyticsEvent: createAnalyticsEvent,
                            data: data,
                            embedUrl: embedUrl
                        }),
                        error: null
                    };
                }
                // We have successfully authenticated with the URL, so lets refetch to get all the
                // proper data.
                const refetchedDetails = await cardClient.fetchData(embedUrl);
                meta = refetchedDetails && refetchedDetails.meta;
                if (refetchedDetails && refetchedDetails.data) data = refetchedDetails.data;
            }
        }
        return {
            data: data,
            meta: meta,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: data,
                embedUrl: embedUrl
            }),
            error: null
        };
    } catch (error) {
        return {
            data: undefined,
            meta: undefined,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: undefined,
                embedUrl: embedUrl
            }),
            error: error
        };
    }
};
const $07e4518f8509fec5$export$22fdc6a4626c032 = ()=>{
    const { connections: connections } = (0, $bI14T.useSmartLinkContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fetchEmbedData = (0, $cozmU.useCallback)(async ({ embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
        return $07e4518f8509fec5$export$7053598ec03d6366({
            cardClient: connections.client,
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            includeAuthHandling: includeAuthHandling
        });
    }, [
        connections.client,
        createAnalyticsEvent
    ]);
    return {
        fetchEmbedData: fetchEmbedData
    };
};
module.exports["fetchDataFromORS"] = $07e4518f8509fec5$export$7053598ec03d6366;
module.exports["useFetchDataFromORS"] = $07e4518f8509fec5$export$22fdc6a4626c032;

});

parcelRegister("aUoHg", function(module, exports) {

var $eEPSE = parcelRequire("eEPSE");

const $1d0cc37ef4affcea$export$2b381fecab5b3691 = async ({ authURL: authURL })=>{
    const POPUP_HEIGHT = 600;
    const POPUP_WIDTH = 720;
    const BROWSER_SIZE_THRESHOLD = 48;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    // Center the popup window
    const left = (vw - POPUP_WIDTH) / 2;
    const top = (vh - POPUP_HEIGHT) / 2;
    // Open a popup if there's enough space in the viewport
    // Otherwise, fall back to the default behavior (opening in a new tab)
    const windowFeatures = vw > POPUP_WIDTH + BROWSER_SIZE_THRESHOLD && vh > POPUP_HEIGHT + BROWSER_SIZE_THRESHOLD ? `width=${POPUP_WIDTH},height=${POPUP_HEIGHT}},left=${left},top=${top}` : undefined;
    await (0, $eEPSE.auth)(authURL, windowFeatures);
};
module.exports["handleEmbedAuthentication"] = $1d0cc37ef4affcea$export$2b381fecab5b3691;

});

parcelRegister("eaBPu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9QoCS = parcelRequire("9QoCS");

const $86c9e03e9bf37880$export$c6a11f4b62c81749 = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    try {
        return (0, $9QoCS.extractProduct)(embedUrl, data || undefined);
    } catch (error) {
        createAnalyticsEvent?.({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'embedProductExtraction',
                source: 'smartLinkEmbedProductExtraction',
                attributes: {
                    contentType: 'embed'
                }
            }
        }).fire();
        return null;
    }
};
const $86c9e03e9bf37880$export$fe632efa34893174 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const _extractEmbedProduct = (0, $cozmU.useCallback)(({ data: data, embedUrl: embedUrl })=>{
        return $86c9e03e9bf37880$export$c6a11f4b62c81749({
            createAnalyticsEvent: createAnalyticsEvent,
            data: data,
            embedUrl: embedUrl
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        extractEmbedProduct: _extractEmbedProduct
    };
};
module.exports["extractEmbedProduct"] = $86c9e03e9bf37880$export$c6a11f4b62c81749;

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return(// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages'));
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("dkIiA", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("gMtye", function(module, exports) {
const $1fd4d6f991517194$export$28213145aa06a6b9 = 'is-smart-link-dragging';
const $1fd4d6f991517194$export$a20e94b83f364b00 = 'smart-link-drop-over';
const $1fd4d6f991517194$export$9cd8e72bb371a8c0 = 'smartLinkDnD';
module.exports["smartLinkDropOverClass"] = $1fd4d6f991517194$export$a20e94b83f364b00;
module.exports["SMART_LINK_DND_ANALYTICS_SOURCE"] = $1fd4d6f991517194$export$9cd8e72bb371a8c0;

});

parcelRegister("gAsUX", function(module, exports) {
/* SmartLinkDropTarget.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iIYTj = parcelRequire("iIYTj");


var $4Vdlk = parcelRequire("4Vdlk");


var $gMtye = parcelRequire("gMtye");

const $da2fe9c7e62c2676$var$EDGE_BORDER_HIDE_THRESHOLD_PX = 8;
const $da2fe9c7e62c2676$var$topBorderColorVar = '--smart-link-drop-target-border-top-color';
const $da2fe9c7e62c2676$var$bottomBorderColorVar = '--smart-link-drop-target-border-bottom-color';
const $da2fe9c7e62c2676$var$smartLinkDropTargetStyles = null;
function $da2fe9c7e62c2676$export$427c9f1706ef8816({ onDropped: onDropped, children: children, className: className, hideHoveredEdgeBorder: hideHoveredEdgeBorder = false }) {
    const ref = (0, $cozmU.useRef)(null);
    const clearHoveredEdgeBorder = (0, $cozmU.useCallback)((element)=>{
        element.style.removeProperty($da2fe9c7e62c2676$var$topBorderColorVar);
        element.style.removeProperty($da2fe9c7e62c2676$var$bottomBorderColorVar);
    }, []);
    const updateHoveredEdgeBorder = (0, $cozmU.useCallback)((element, clientY)=>{
        if (!hideHoveredEdgeBorder) {
            clearHoveredEdgeBorder(element);
            return;
        }
        const rect = element.getBoundingClientRect();
        const threshold = Math.min($da2fe9c7e62c2676$var$EDGE_BORDER_HIDE_THRESHOLD_PX, rect.height / 2);
        const distanceFromTop = clientY - rect.top;
        const distanceFromBottom = rect.bottom - clientY;
        const isNearTop = distanceFromTop >= 0 && distanceFromTop <= threshold && distanceFromTop <= distanceFromBottom;
        const isNearBottom = distanceFromBottom >= 0 && distanceFromBottom <= threshold && distanceFromBottom < distanceFromTop;
        if (isNearTop) {
            element.style.setProperty($da2fe9c7e62c2676$var$topBorderColorVar, 'transparent');
            element.style.removeProperty($da2fe9c7e62c2676$var$bottomBorderColorVar);
            return;
        }
        if (isNearBottom) {
            element.style.setProperty($da2fe9c7e62c2676$var$bottomBorderColorVar, 'transparent');
            element.style.removeProperty($da2fe9c7e62c2676$var$topBorderColorVar);
            return;
        }
        clearHoveredEdgeBorder(element);
    }, [
        clearHoveredEdgeBorder,
        hideHoveredEdgeBorder
    ]);
    const updateHoveredEdgeBorderFromLocation = (0, $cozmU.useCallback)((element, location)=>{
        const clientY = location?.current?.input?.clientY;
        if (typeof clientY !== 'number') {
            clearHoveredEdgeBorder(element);
            return;
        }
        updateHoveredEdgeBorder(element, clientY);
    }, [
        clearHoveredEdgeBorder,
        updateHoveredEdgeBorder
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        return (0, $4Vdlk.dropTargetForElements)({
            element: el,
            canDrop: ({ source: source })=>(0, $iIYTj.isSmartLinkDrag)(source.data.type),
            onDragEnter: (args)=>{
                el.classList.add((0, $gMtye.smartLinkDropOverClass));
                updateHoveredEdgeBorderFromLocation(el, args?.location);
            },
            onDrag: (args)=>{
                updateHoveredEdgeBorderFromLocation(el, args?.location);
            },
            onDragLeave: ()=>{
                el.classList.remove((0, $gMtye.smartLinkDropOverClass));
                clearHoveredEdgeBorder(el);
            },
            onDrop: ({ source: source })=>{
                el.classList.remove((0, $gMtye.smartLinkDropOverClass));
                clearHoveredEdgeBorder(el);
                onDropped?.(source.data);
            }
        });
    }, [
        clearHoveredEdgeBorder,
        onDropped,
        updateHoveredEdgeBorderFromLocation
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _39xV02N91d _1mT5xdRAKS _2yCP7AjOvk _0b0sXJmWpW _1i2vG6mWpW _4jFnWednbC _2FDR3vhtzl _1OimfuOLYo _3Ku51Iogpp _3dCYwDWVPG _2d4ornO3rM _3mbOcOm0w7 _0UsFEzYbGa _2JcWvBrzt2 _0bbpL3sumd _2iqICrrzt2",
            className
        ])
    }, children);
}
module.exports["SmartLinkDropTarget"] = $da2fe9c7e62c2676$export$427c9f1706ef8816;

});

parcelRegister("ftFOj", function(module, exports) {

var $ieWRE = parcelRequire("ieWRE");


var $jtuBN = parcelRequire("jtuBN");


var $gZneu = parcelRequire("gZneu");

/** @schema cc */ const $46cf70134ef7593d$var$query = (0, $ieWRE.default);
const $46cf70134ef7593d$export$957cf4ab6fd3f58e = (spaceKey)=>{
    const isSmartFoldersSupported = (0, $gZneu.useIsSmartFoldersSupported)();
    const shouldSkipQuery = !isSmartFoldersSupported || !spaceKey;
    const { loading: loading, data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($46cf70134ef7593d$var$query, {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: shouldSkipQuery,
        __callerPackage__: "smart-folder"
    });
    const enabledContentTypes = data?.space?.spaceTypeSettings?.enabledContentTypes;
    const isFoldersEnabledInSpace = enabledContentTypes?.isFoldersEnabled ?? false;
    const isSmartFoldersEnabledInSpace = enabledContentTypes?.isSmartFoldersEnabled ?? false;
    return {
        isSmartFoldersEnabled: isSmartFoldersSupported && isFoldersEnabledInSpace && isSmartFoldersEnabledInSpace,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabled"] = $46cf70134ef7593d$export$957cf4ab6fd3f58e;

});

parcelRegister("gZneu", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $23af0ee2a39f4a09$export$4f0b8fcf328460ea = ()=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoEnabled && (0, $6mKj3.expVal)('confluence_smart_folders_milestone_1', 'isEnabled', false);
};
module.exports["useIsSmartFoldersSupported"] = $23af0ee2a39f4a09$export$4f0b8fcf328460ea;

});

parcelRegister("lY1lm", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cd81aae1dd865317$export$56ef5168f507b51a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6xpDa",
    name: "TreeMonitorLoader",
    loader: async ()=>(await (parcelRequire("g2aIc"))).TreeMonitor
});
module.exports["TreeMonitorLoader"] = $cd81aae1dd865317$export$56ef5168f507b51a;

});

parcelRegister("g2aIc", function(module, exports) {

let $bac5246dc63f4126$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bac5246dc63f4126$var$load("cBeoH"),
    $bac5246dc63f4126$var$load("lN9TX"),
    $bac5246dc63f4126$var$load("abBST"),
    $bac5246dc63f4126$var$load("Tjs4D"),
    $bac5246dc63f4126$var$load("f9QHk")
]).then(()=>parcelRequire('e14IX'));

});

parcelRegister("g0MxG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ab7921964510845f$export$e3668039106e3bc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CQdGh",
    name: "PageTreeAfterIconLoader",
    loader: async ()=>(await (parcelRequire("eIS7X"))).PageTreeAfterIcon
});
module.exports["PageTreeAfterIconLoader"] = $ab7921964510845f$export$e3668039106e3bc;

});

parcelRegister("eIS7X", function(module, exports) {

let $ab7f2950d3fd9ece$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ab7f2950d3fd9ece$var$load("hsRa9"),
    $ab7f2950d3fd9ece$var$load("bEleE"),
    $ab7f2950d3fd9ece$var$load("6wr18"),
    $ab7f2950d3fd9ece$var$load("gUrlb"),
    $ab7f2950d3fd9ece$var$load("ffEVr"),
    $ab7f2950d3fd9ece$var$load("5gsbh"),
    $ab7f2950d3fd9ece$var$load("8OeKT"),
    $ab7f2950d3fd9ece$var$load("dkv9z")
]).then(()=>parcelRequire('4Nj9v'));

});

parcelRegister("jwg5H", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ed61048aa16089ca$export$a423abb15d3d6d30 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "OOnQb",
    name: "BulkDeletePagesActionLoader",
    loader: async ()=>(await (parcelRequire("57jGo"))).BulkDeletePagesAction
});
module.exports["BulkDeletePagesActionLoader"] = $ed61048aa16089ca$export$a423abb15d3d6d30;

});

parcelRegister("57jGo", function(module, exports) {

let $3b9cdfc9cfbce8bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b9cdfc9cfbce8bf$var$load("6wr18"),
    $3b9cdfc9cfbce8bf$var$load("33ouG"),
    $3b9cdfc9cfbce8bf$var$load("73HOd"),
    $3b9cdfc9cfbce8bf$var$load("ffEVr"),
    $3b9cdfc9cfbce8bf$var$load("Wowvf"),
    $3b9cdfc9cfbce8bf$var$load("jXx9i"),
    $3b9cdfc9cfbce8bf$var$load("hhss7"),
    $3b9cdfc9cfbce8bf$var$load("4JUnA")
]).then(()=>parcelRequire('11cB0'));

});

parcelRegister("eQjI7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f8c65fa1d909f5a2$export$3ef64b4ca9fc58eb = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Xv9Y3",
    name: "BulkArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("lBgD3"))).BulkArchivePagesLoader
});
module.exports["BulkArchivePagesLoader"] = $f8c65fa1d909f5a2$export$3ef64b4ca9fc58eb;

});

parcelRegister("lBgD3", function(module, exports) {

let $fb99f3d339a23976$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fb99f3d339a23976$var$load("kGnv3"),
    $fb99f3d339a23976$var$load("kPpF9"),
    $fb99f3d339a23976$var$load("abBST"),
    $fb99f3d339a23976$var$load("6wr18"),
    $fb99f3d339a23976$var$load("4QN8n"),
    $fb99f3d339a23976$var$load("ffEVr"),
    $fb99f3d339a23976$var$load("Wowvf"),
    $fb99f3d339a23976$var$load("iWnyc"),
    $fb99f3d339a23976$var$load("jXx9i"),
    $fb99f3d339a23976$var$load("hhss7"),
    $fb99f3d339a23976$var$load("anGwD")
]).then(()=>parcelRequire('1nPts'));

});

parcelRegister("abCbd", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $49f30f782ee3886b$export$dde867dc2e19cdfb = /*#__PURE__*/ function(ActionStatus) {
    ActionStatus["LOADING"] = "loading";
    ActionStatus["ERROR"] = "error";
    ActionStatus["SUCCESS"] = "success";
    return ActionStatus;
}({});
const $49f30f782ee3886b$export$a047e1504a58a095 = 'https://support.atlassian.com/contact/#/';
const $49f30f782ee3886b$export$992f6917cca3802d = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/';
const $49f30f782ee3886b$export$f077813e47f96ab7 = 'https://support.atlassian.com/confluence-cloud/docs/delete-restore-or-purge-a-page/';
const $49f30f782ee3886b$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
var $49f30f782ee3886b$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["ARCHIVED"] = "archived";
    ContentStatus["RESTORED"] = "restored";
    // Trashed pages can be restored.
    ContentStatus["TRASHED"] = "trashed";
    return ContentStatus;
}({});
const $49f30f782ee3886b$export$c047260051351df3 = 100;
module.exports["ActionStatus"] = $49f30f782ee3886b$export$dde867dc2e19cdfb;
module.exports["LINK_TO_SUPPORT_CONTACT"] = $49f30f782ee3886b$export$a047e1504a58a095;
module.exports["ARCHIVE_SUPPORT_LINK"] = $49f30f782ee3886b$export$992f6917cca3802d;
module.exports["DELETE_SUPPORT_LINK"] = $49f30f782ee3886b$export$f077813e47f96ab7;
module.exports["PAGE_RESTRICTIONS_SUPPORT_LINK"] = $49f30f782ee3886b$export$90622b83e51be397;
module.exports["ContentStatus"] = $49f30f782ee3886b$export$b2be22e9d5dd3927;
module.exports["BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT"] = $49f30f782ee3886b$export$c047260051351df3;

});

parcelRegister("ibHYv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $982461640a7c7c8c$export$a4add0dacb108c5e = 'twcg-2112-twc-xflow-conf-pages-templates';
const $982461640a7c7c8c$var$PostOfficeSideNavMessageContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $982461640a7c7c8c$export$730cc5718beea0d0 = ()=>{
    return (0, $cozmU.useContext)($982461640a7c7c8c$var$PostOfficeSideNavMessageContext);
};
const $982461640a7c7c8c$export$1a1a764f5b0fd0ac = ({ children: children })=>{
    const [enabledMessages, setEnabledMessages] = (0, $cozmU.useState)([]);
    const enablePostOfficeSideNavMessage = (0, $cozmU.useCallback)((message)=>{
        setEnabledMessages((prev)=>{
            if (prev.includes(message)) return prev;
            return [
                ...prev,
                message
            ];
        });
    }, []);
    const disablePostOfficeSideNavMessage = (0, $cozmU.useCallback)((message)=>{
        setEnabledMessages((prev)=>prev.includes(message) ? prev.filter((enabledMessage)=>enabledMessage !== message) : prev);
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            enabledMessages: enabledMessages,
            enablePostOfficeSideNavMessage: enablePostOfficeSideNavMessage,
            disablePostOfficeSideNavMessage: disablePostOfficeSideNavMessage
        }), [
        enabledMessages,
        enablePostOfficeSideNavMessage,
        disablePostOfficeSideNavMessage
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($982461640a7c7c8c$var$PostOfficeSideNavMessageContext.Provider, {
        value: value,
        children: children
    });
};
module.exports["TEMPLATE_XFLOW_EXPERIMENT_KEY"] = $982461640a7c7c8c$export$a4add0dacb108c5e;
module.exports["usePostOfficeSideNavMessages"] = $982461640a7c7c8c$export$730cc5718beea0d0;
module.exports["PostOfficeSideNavMessageProvider"] = $982461640a7c7c8c$export$1a1a764f5b0fd0ac;

});

parcelRegister("jAOzg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $9612d889a12dc002$var$createSyncStore() {
    let syncingFolderIds = new Set();
    const listeners = new Set();
    const notify = ()=>{
        listeners.forEach((listener)=>listener());
    };
    return {
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        },
        getSnapshot: ()=>syncingFolderIds,
        addSyncingFolder: (folderId)=>{
            if (syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.add(folderId);
            syncingFolderIds = next;
            notify();
        },
        removeSyncingFolder: (folderId)=>{
            if (!syncingFolderIds.has(folderId)) return;
            const next = new Set(syncingFolderIds);
            next.delete(folderId);
            syncingFolderIds = next;
            notify();
        }
    };
}
/**
 * A store-based context for tracking which folders are syncing.
 *
 * Uses `useSyncExternalStore` so that each `useIsFolderSyncing(folderId)`
 * subscriber only re-renders when their specific folder's sync boolean
 * changes — not when any arbitrary folder starts/stops syncing.
 *
 * - `SmartFolderSyncStoreContext` holds the store instance.
 * - `SmartFolderSyncActionsContext` holds stable `add`/`remove` callbacks
 *   for writers (e.g. `useSmartFolderSync`) that never re-render on state change.
 */ const $9612d889a12dc002$var$SmartFolderSyncStoreContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $9612d889a12dc002$var$SmartFolderSyncActionsContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    addSyncingFolder: ()=>{},
    removeSyncingFolder: ()=>{}
});
const $9612d889a12dc002$export$a225af674c9c7799 = ({ children: children })=>{
    const storeRef = (0, $cozmU.useRef)(null);
    if (storeRef.current === null) storeRef.current = $9612d889a12dc002$var$createSyncStore();
    const store = storeRef.current;
    const actions = (0, $cozmU.useMemo)(()=>({
            addSyncingFolder: store.addSyncingFolder,
            removeSyncingFolder: store.removeSyncingFolder
        }), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9612d889a12dc002$var$SmartFolderSyncStoreContext.Provider, {
        value: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9612d889a12dc002$var$SmartFolderSyncActionsContext.Provider, {
        value: actions
    }, children));
};
const $9612d889a12dc002$var$EMPTY_SET = new Set();
const $9612d889a12dc002$var$EMPTY_SUBSCRIBE = (_cb)=>()=>{};
const $9612d889a12dc002$var$EMPTY_SNAPSHOT = ()=>$9612d889a12dc002$var$EMPTY_SET;
const $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL = ()=>false;
const $9612d889a12dc002$export$35a8d8248145227a = ()=>{
    const store = (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    return (0, $cozmU.useSyncExternalStore)(store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE, store?.getSnapshot ?? $9612d889a12dc002$var$EMPTY_SNAPSHOT, $9612d889a12dc002$var$EMPTY_SNAPSHOT);
};
const $9612d889a12dc002$export$4cd077b71db9ec99 = (folderId)=>{
    const store = (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncStoreContext);
    const subscribe = store?.subscribe ?? $9612d889a12dc002$var$EMPTY_SUBSCRIBE;
    const getSnapshot = (0, $cozmU.useCallback)(()=>store ? store.getSnapshot().has(folderId) : false, [
        store,
        folderId
    ]);
    return (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, $9612d889a12dc002$var$SERVER_SNAPSHOT_BOOL);
};
const $9612d889a12dc002$export$8a3c75bc060e9cf8 = ()=>{
    return (0, $cozmU.useContext)($9612d889a12dc002$var$SmartFolderSyncActionsContext);
};
const $9612d889a12dc002$export$f1204087fc222a72 = (folderId, isSyncing)=>{
    const { addSyncingFolder: addSyncingFolder, removeSyncingFolder: removeSyncingFolder } = $9612d889a12dc002$export$8a3c75bc060e9cf8();
    (0, $cozmU.useEffect)(()=>{
        if (!isSyncing) return;
        addSyncingFolder(folderId);
        return ()=>{
            removeSyncingFolder(folderId);
        };
    }, [
        addSyncingFolder,
        folderId,
        isSyncing,
        removeSyncingFolder
    ]);
};
module.exports["SmartFolderSyncProvider"] = $9612d889a12dc002$export$a225af674c9c7799;
module.exports["useIsFolderSyncing"] = $9612d889a12dc002$export$4cd077b71db9ec99;
module.exports["useFolderSyncActions"] = $9612d889a12dc002$export$8a3c75bc060e9cf8;
module.exports["usePublishSmartFolderSyncState"] = $9612d889a12dc002$export$f1204087fc222a72;

});

parcelRegister("8hkPB", function(module, exports) {
/* SmartFolderSyncIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $iMZH0 = parcelRequire("iMZH0");

const $ae9f424642e328f9$var$i18n = (0, $kSwu1.defineMessages)({
    syncingFolder: {
        id: "smart-folder.sync-icon.syncing",
        defaultMessage: "Syncing folder"
    }
});
const $ae9f424642e328f9$var$spinAnimation = null;
const $ae9f424642e328f9$var$styles = {
    root: "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _1gBibySaH4 _0nFVCGIoAq _03m2nySHWH _43vdfTHVQb"
}; /**
    * A small animated sync icon shown while a smart folder is being synchronised.
    *
    * Renders a rotating `SyncIcon` wrapped in an `inline-flex` container.
    * The animation is applied to the wrapper (not the SVG itself) so that React
    * re-renders of the SVG do not reset the spin timeline.
    */ 
const $ae9f424642e328f9$export$ff90b815577daa98 = ({ testId: testId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const label = intl.formatMessage($ae9f424642e328f9$var$i18n.syncingFolder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $ae9f424642e328f9$var$styles.root,
        testId: testId,
        role: "status",
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iMZH0))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};
module.exports["SmartFolderSyncIcon"] = $ae9f424642e328f9$export$ff90b815577daa98;

});


//# sourceMappingURL=PageTree.cebdc023.js.map
